import organization from './organization/en'
import themeSceneExport from './themeSceneExport/en'

export default {
    route: {
        Dashboard: 'Dashboard',
        rt_tt_DMSystem: 'System',
        rt_tt_MbManage: 'Board Manage',
        rt_tt_MbControlNew: 'PC Control',
        rt_tt_MbInfo: 'Board Info',
        rt_tt_MbRunRecord: 'Run Record',
        rt_tt_ThemeEdit: 'Theme Edit',
        rt_tt_ThmSceneEdit: 'Scene Edit',
        rt_tt_ThmDevEdit: 'Dev Edit',
        rt_tt_ThmTaskEdit: 'Task Edit',
        rt_tt_SystemSetting: 'Sys Setting',
        rt_tt_SystemManage: 'Sys Manage',
        rt_tt_UserManage: 'User Manage',
        rt_tt_DevManage: 'Board Manage',
        rt_org_management: 'Organization Management',
        rt_org_access: 'Organization Access',
        rt_org_users: 'Organization Users',
        rt_role_permissions: 'Roles & Permissions',
        rt_device_resources: 'Device Resources',
        rt_my_boards: 'My Boards',
        rt_org_boards: 'Organization Devices',
        rt_platform_boards: 'Platform Device Operations',
        rt_org_themes: 'Organization Themes',
    },
    page: {
        p99_nav_home : 'Home',
        p99_nav_sivatech : 'SivaTech',
        p99_nav_logout : 'LogOUT',
        p99_sdb_tt_bd : 'Board',
        p99_sdb_tt_pgs : 'Progress',

        p1_dsh_mb_info : 'Board Info',
        p1_dsh_thm_edit : 'Theme Edit',
        p1_dsh_sys_setting : 'Sys Setting',
        p1_dsh_pc_rt_ctl_new : 'PC Control',
        p1_dsh_pc_rt_ctl : 'PC Control',
        p1_dsh_online : 'ACT:',
        p1_dsh_tbshop : 'Online Store',
        p1_dsh_help : 'Knowledge',

        p2_rt2024_lbl_ipt_keyword : 'Enter board or theme name',
        p2_rt2024_lbl_live_only : 'Live only',
        p2_rt2024_show_more : 'Show more',
        p2_rt2024_lbl_wide : 'Wide',
        p2_rt2024_lbl_idle : 'Idle',
        p2_rt2024_lbl_ready : 'Ready',
        p2_rt2024_lbl_running : 'Running',
        p2_rt2024_lbl_finished : 'Finished',
        p2_rt2024_lbl_offline : 'Offline',
        p2_rt2024_lbl_theme : 'Theme: ',
        p2_rt2024_lbl_boot_theme_no_sel : 'No startup theme selected',
        p2_rt2024_lbl_theme_mgr : 'Theme Management',
        p2_rt2024_lbl_no_running_theme : 'No running theme on this board',
        p2_rt2024_lbl_running_theme : 'Running theme',
        p2_rt2024_lbl_sel_theme : 'Please select a theme',
        p2_rt2024_lbl_boot_theme : 'Startup theme',
        p2_rt2024_btn_exec_theme : 'Execute theme',
        p2_rt2024_btn_set_boot_theme : 'Set startup theme',
        p2_rt2024_msg_please_sel : 'Please select',
        p2_rt2024_msg_sel_correct_theme : 'Please select a valid theme',
        p2_rt2024_msg_setting : 'Setting...',
        p2_rt2024_msg_boot_theme_ok : 'Startup theme set successfully',
        p2_rt2024_msg_boot_theme_confirm_fail : 'The controller did not confirm the startup theme. Please try again later.',
        p2_rt2024_msg_theme_switching : 'Theme switched, loading theme content...',
        p2_rt2024_msg_scene_sync_retry : 'Scene data sync failed, retrying...',
        p2_rt2024_msg_scene_sync_fail : 'Scene data sync failed. Please check the network and re-enter the theme',
        p2_rt2024_lbl_api_latency : 'API latency',
        p2_rt2024_lbl_api_latency_fail : 'Failed',
        p2_rt2024_lbl_api_latency_scene_info : 'Current theme info',
        p2_rt2024_lbl_api_latency_theme_list : 'Theme list',
        p2_rt2024_lbl_api_latency_board_info : 'Board info',
        p2_rt2024_lbl_api_latency_res_config : 'Resource config',
        p2_rt2024_lbl_api_latency_int_param : 'Runtime params',
        p2_rt2024_lbl_api_latency_subdev_info : 'Device info',
        p2_rt2024_lbl_dev_type : 'Device type',
        p2_rt2024_lbl_board_type_main : 'Cloud Controller',
        p2_rt2024_lbl_board_type_plus : 'Cloud Controller Plus',
        p2_rt2024_lbl_board_type_nio : 'Network Port Controller',
        p2_rt2024_lbl_board_type_na : 'Network Audio Controller',
        p2_rt2024_lbl_dev_offline : 'Offline',
        p2_rt2024_lbl_dev_online : 'Online',
        p2_rt2024_lbl_net_dev : 'Network device',
        p2_rt2024_lbl_lang_default : 'Default',
        p2_rt2024_lbl_lang_chi : 'Chinese(chi)',
        p2_rt2024_lbl_lang_eng : 'English(eng)',
        p2_rt2024_lbl_lang_jpn : 'Japanese(jpn)',
        p2_rt2024_lbl_lang_kor : 'Korean(kor)',
        p2_rt2024_lbl_run_limit_prefix : 'Can run until: ',
        p2_rt2024_lbl_loading : 'Loading data',
        p2_rt2024_msg_task_skip_ok : 'Task skip success',
        p2_rt2024_msg_task_skip_fail : 'Task skip failed',
        p2_rt2024_msg_skip_ok : 'Skip success',
        p2_rt2024_msg_scene_jump_ok : 'Scene jump success',
        p2_rt2024_msg_scene_jump_fail : 'Scene jump failed',
        p2_rt2024_msg_scene_trig_ok : 'Scene effect trigger success',
        p2_rt2024_msg_scene_trig_fail : 'Scene effect trigger failed',
        p2_rt2024_msg_task_op_ok : 'Task control success',
        p2_rt2024_msg_task_op_fail : 'Task control failed',
        p2_rt2024_msg_operate_ok : 'Operation success',
        p2_rt2024_msg_operate_fail : 'Operation failed',
        p2_rt2024_msg_reboot_ok : 'Device reboot success',

        p2_rt2024_btn_ok : 'OK',
        p2_rt2024_btn_cancel : 'Cancel',
        p2_rt2024_cfm_reboot : 'Confirm reboot?',
        p2_rt2024_btn_reboot : 'Reboot',
        p2_rt2024_lbl_show_act_t : 'Active Tasks',
        p2_rt2024_lbl_refresh : 'Refresh',
        p2_rt2024_lbl_theme_flow : 'Theme flow',
        p2_rt2024_lbl_ipt_dev_name : 'Enter device name',
        p2_rt2024_lbl_show_finished : 'Show finished',
        p2_rt2024_cfm_skip : 'Confirm skip?',
        p2_rt2024_btn_skip : 'Skip',
        p2_rt2024_dev_operate : 'Dev Operate',
        p2_rt2024_lbl_number : 'No.',
        p2_rt2024_lbl_port : 'Port',
        p2_rt2024_lbl_none : 'None',
        p2_rt2024_lbl_name : 'Name',
        p2_rt2024_lbl_status : 'Status',
        p2_rt2024_lbl_operate : 'Operate',
        p2_rt2024_lbl_fuzzy_query : 'Keyword fuzzy query',
        p2_rt2024_lbl_effect_trig : 'Effects Trigger',
        p2_rt2024_lbl_trigger : 'Trigger',
        p2_rt2024_lbl_process_test : 'Process Test',
        p2_rt2024_lbl_port_info : 'Port info',
        p2_rt2024_lbl_board_setting : 'Board Setting',
        p2_rt2024_lbl_loading : 'Loading',

        p2_2_rt_c_bpV5_ip : 'INPUT',
        p2_2_rt_c_bpV5_ipb : 'INPUT BOARD',
        p2_2_rt_c_bpV5_op : 'OUTPUT',
        p2_2_rt_c_bpV5_opb : 'OUTPUT BOARD',

        p2_3_rt_c_bs_cfgdata : 'CFG DATA',
        p2_3_rt_c_bs_pctn : 'Purchansed Task num',
        p2_3_rt_c_bs_actn : 'Actual Task num',
        p2_3_rt_c_bs_pr_cnt : 'Purchansed rounds',
        p2_3_rt_c_bs_ur_cnt : 'Used rounds',
        p2_3_rt_c_bs_hw_ver : 'HW Version',
        p2_3_rt_c_bs_sw_ver : 'FW Version',
        p2_3_rt_c_bs_btn_okay : 'OK',
        p2_3_rt_c_bs_btn_cancel : 'Cancel',
        p2_3_rt_c_bs_confirm_upd : 'Confirm Upgrade?',
        p2_3_rt_c_bs_do_upd : 'UPD',
        p2_3_rt_c_bs_more : 'More',
        p2_3_rt_c_bs_cfg_addr : 'URL Setting',
        p2_3_rt_c_bs_pls_input : 'Input',
        p2_3_rt_c_bs_addr_modify : 'URL Modify',
        p2_3_rt_c_bs_thm_update : 'Theme upd',
        p2_3_rt_c_bs_fw_addr : 'Firmware URL',
        p2_3_rt_c_bs_fw_addr_pls_input : 'Please enter firmware URL',
        p2_3_rt_c_bs_fw_addr_invalid : 'The firmware URL must be at most 115 characters and contain only single-byte characters.',
        p2_3_rt_c_bs_fw_update : 'Firmware upgrade',
        p2_3_rt_c_bs_resource : 'Resource',
        p2_3_rt_c_bs_vid_mode : 'Vid mode',
        p2_3_rt_c_bs_v_cont_ud_str : 'Files are located in Udisk',
        p2_3_rt_c_bs_local : 'Local',
        p2_3_rt_c_bs_v_cont_inet_str : 'Files are located in inet server',
        p2_3_rt_c_bs_svr_url : 'Server URL',
        p2_3_rt_c_bs_v_cont_lan_str : 'Files are located ln local server',
        p2_3_rt_c_bs_svr_lan_url : 'Server IP(LAN)',
        p2_3_rt_c_bs_aud_mode : 'Aud mode',
        p2_3_rt_c_bs_a_cont_ud_str : 'Files are located in Udisk',
        p2_3_rt_c_bs_btn_save : 'Save',
        p2_3_rt_c_bs_pls_input_svr_url : 'Please set server url',
        p2_3_rt_c_bs_svr_lan_ip : 'Server IP(LAN)',
        p2_3_rt_c_bs_ipt_svr_ip : 'Please set server ip',
        p2_3_rt_c_bs_svr_port : 'Server port',
        p2_3_rt_c_bs_aud_stb_id : 'Aud STB network id',
        p2_3_rt_c_bs_param_cfg : 'Param setting',
        p2_3_rt_c_bs_detail_rtinfo : 'Detailed RT info',
        p2_3_rt_c_bs_run_mode : 'Mode',
        p2_3_rt_c_bs_port_mode : 'Port mode',
        p2_3_rt_c_bs_net_dev_man : 'Network dev man',
        p2_3_rt_c_bs_net_reconn : 'Network retry',
        p2_3_rt_c_bs_nio_feature : 'NIO feature',
        p2_3_rt_c_bs_btn_update : 'Update',
        p2_3_rt_c_bs_lbl_unlimit : 'Unlimit',
        p2_3_rt_c_bs_lbl_unknown : 'Unknown',
        p2_3_rt_c_bs_lbl_bootcnt : 'BootCnt',
        p2_3_rt_c_bs_lbl_lang : 'Lang',
        p2_3_rt_c_bs_lbl_res_code : 'Resource code',
        p2_3_rt_c_bs_lbl_dev_id : 'Device ID',
        p2_3_rt_c_bs_lbl_play_mode : 'Playback mode',
        p2_3_rt_c_bs_lbl_sel_play_mode : 'Please select playback mode',
        p2_3_rt_c_bs_lbl_def_vol : 'Default volume',
        p2_3_rt_c_bs_lbl_ext_amp : 'External amplifier',
        p2_3_rt_c_bs_lbl_switch_on : 'On',
        p2_3_rt_c_bs_lbl_switch_off : 'Off',
        p2_3_rt_c_bs_lbl_audio_ctrl : 'Audio control',
        p2_3_rt_c_bs_lbl_port_limit : 'Port limit settings',
        p2_3_rt_c_bs_lbl_limit : 'Limited',
        p2_3_rt_c_bs_lbl_no_limit : 'Unlimited',
        p2_3_rt_c_bs_lbl_sel_date : 'Select date and time',
        p2_3_rt_c_bs_lbl_single_stop : 'Single stop',
        p2_3_rt_c_bs_lbl_single_loop : 'Single loop',
        p2_3_rt_c_bs_label_debug : 'Debug info level',
        p2_3_rt_c_bs_cloud_server : 'Cloud server',
        p2_3_rt_c_bs_admin_param : 'Admin Parameters',
        p2_3_rt_c_bs_run_limit : 'Run time limit',
        p2_3_rt_c_bs_msg_fw_done : 'Upgrade complete',
        p2_3_rt_c_bs_msg_fw_start : 'Upgrade started',
        p2_3_rt_c_bs_msg_fw_fail : 'Upgrade failed',
        p2_3_rt_c_bs_msg_thm_done : 'Theme upgrade complete',
        p2_3_rt_c_bs_msg_thm_timeout : 'Theme upgrade timeout',
        p2_3_rt_c_bs_msg_thm_start : 'Theme update started',
        p2_3_rt_c_bs_msg_cfg_ok : 'Config updated successfully',
        p2_3_rt_c_bs_msg_cfg1_ok : 'Config 1 updated successfully',
        p2_3_rt_c_bs_msg_cfg2_ok : 'Config 2 updated successfully',
        p2_5_rt_c_bw_lbl_cloud_days : 'Cloud control days',
        p2_5_rt_c_bw_lbl_contact_svc : 'Please contact support if expired',
        p2_5_rt_c_bw_lbl_infinite : 'Unlimited',
        p2_5_rt_c_bw_lbl_expired : 'Expired',
        p2_5_rt_c_bw_lbl_days : 'days',
        p2_5_rt_c_bw_msg_skip_ok : 'Skip success',
        p2_6_rt_c_tsk_c_lbl_scene_skip_title : 'Please select scene to jump to',
        p2_6_rt_c_tsk_c_btn_close : 'Close',
        p2_6_rt_c_tsk_c_btn_confirm : 'Confirm',
        p2_6_rt_c_tsk_c_lbl_assign : 'Assign',
        p2_6_rt_c_tsk_c_lbl_become : 'Become',
        bit_edit_lbl_current_val : 'Current value',
        bit_edit_lbl_input_hint : 'Enter integer (supports 0x hex):',
        bit_edit_lbl_decimal_val : 'Value (decimal):',
        bit_edit_lbl_hex_val : 'Value (hex):',
        bit_edit_lbl_readonly : 'Read-only',
        bit_edit_lbl_bit : 'Bit',
        bit_edit_lbl_bits : 'Bits',
        bit_edit_lbl_hex : 'HEX',
        bit_edit_lbl_dec : 'DEC',
        extra_param_desc_debug_level : 'Debug information level (0-F, 1-E, 2-E, 3-I, 4-V)',
        extra_param_desc_serial_print : 'Enable serial printing',
        extra_param_desc_action_log_suppression : 'Suppress action logs during operation',
        extra_param_desc_disable_network_log : 'Disable network logs',
        extra_param_desc_task_end_mode : 'Task end mode',
        extra_param_desc_skip_mode : 'Skip mode',
        extra_param_desc_stop_same_port_output : 'Stop output devices on the same port',
        extra_param_desc_ms_unit : 'Milliseconds unit',
        extra_param_desc_multi_card_ic_timing : 'Multi-card IC (0) 2 ms/(1) 4 ms',
        extra_param_desc_remote_control_timing : 'Remote control (0) 8 ms/(1) 4 ms',
        extra_param_desc_multi_card_gap : 'Use GAP for multi-card',
        extra_param_desc_nio_input_change_log : 'Log NIO input port changes',
        extra_param_desc_input_port_ll : 'Input port LL',
        extra_param_desc_output_port_ll : 'Output port LL',
        extra_param_desc_volume_control : 'Volume control',
        extra_param_desc_timer_volume_control : 'Send volume control by timer',
        extra_param_desc_reconnect_count : 'Disconnect reconnect count',
        extra_param_desc_network_discovery_timeout : 'Network device discovery timeout',
        extra_param_desc_sockcomm_no_check : 'Disable sockcomm reply checksum',
        extra_param_desc_udp_token_check : 'Validate network port board UDP token',
        extra_param_desc_udp_sequence_check : 'Validate network port board UDP sequence number',
        extra_param_desc_http_download_optimization : 'Optimize HTTP downloads',
        extra_param_desc_networkctrl_tcp_async_send : 'Asynchronous networkctrl TCP send',
        extra_param_desc_mobile_network_optimization : 'Optimize mobile networks',
        extra_param_desc_networkctrl_tcp_async_drop : 'Support asynchronous networkctrl TCP DROP',
        extra_param_desc_input_port_status_log : 'Log port status changes in Input packets',
        extra_param_desc_retransmission : 'Retransmission mechanism',
        extra_param_desc_extradata_crc_check : 'ExtraData CRC validation',
        extra_param_desc_input_module_limit : 'Input module limit (0 = unlimited)',
        extra_param_desc_output_module_limit : 'Output module limit (0 = unlimited)',
        extra_param_desc_cloud_server : 'Cloud server connection selection (0-2)',




        p2_4_rt_c_b5_rbt_board : 'Reboot Board',
        p2_4_rt_c_b5_btn_ok : 'OK',
        p2_4_rt_c_b5_btn_cancel : 'Cancel',
        p2_4_rt_c_b5_cfm_reboot : 'Confirm reboot',
        p2_4_rt_c_b5_lbl_idle : 'Idle',
        p2_4_rt_c_b5_lbl_ready : 'Ready',
        p2_4_rt_c_b5_lbl_running : 'Running',
        p2_4_rt_c_b5_lbl_finished : 'Finished',
        p2_4_rt_c_b5_lbl_offline : 'Offline',
        p2_4_rt_c_b5_lbl_time : 'Time',
        p2_4_rt_c_b5_lbl_detail : 'Detail',
        p2_4_rt_c_b5_lbl_inf : 'Indef.',
        p2_4_rt_c_b5_lbl_outdated : 'Expired ',
        p2_4_rt_c_b5_lbl_day : 'Day(s)',
        p2_4_rt_c_b5_msg_v_days : 'Days Available for Cloud Control',
        p2_4_rt_c_b5_msg_contact : 'If expired, please contact customer service.',


        p2_5_rt_c_bw_btn_ok : 'OK',
        p2_5_rt_c_bw_btn_cancel : 'Cancel',
        p2_5_rt_c_bw_cfm_reboot : 'Confirm reboot?',
        p2_5_rt_c_bw_cfm_skip : 'Confirm skip?',
        p2_5_rt_c_bw_lbl_time : 'Time',
        p2_5_rt_c_bw_scene_skip : 'Skip',
        p2_5_rt_c_bw_lbl_detail : 'Detail',

        p2_6_rt_c_tsk_c_lbl_task : 'Task',
        p2_6_rt_c_tsk_c_lbl_show_finish : 'Show finished',
        p2_6_rt_c_tsk_c_btn_ok : 'OK',
        p2_6_rt_c_tsk_c_btn_cancel : 'Cancel',
        p2_6_rt_c_tsk_c_cfm_skip : 'Confirm skip?',
        p2_6_rt_c_tsk_c_btn_skip : 'Skip next',
        p2_6_rt_c_tsk_c_msg_skip_ok : 'Task scene skip success',
        p2_6_rt_c_tsk_c_msg_skip_fail : 'Task scene skip failed',
        p2_6_rt_c_tsk_c_msg_op_success : 'Task operate success',
        p2_6_rt_c_tsk_c_msg_op_fail : 'Task operate failed',
        p2_6_rt_c_tsk_c_msg_scene_lst : 'Scene List',
        p6_te_scn_lbl_math_add : 'plus',
        p6_te_scn_lbl_math_sub : 'minus',
        p6_te_scn_lbl_math_mul : 'mul by',
        p6_te_scn_lbl_math_div : 'div by',
        p6_te_scn_msg_scene_lst : 'Scene List',
        p2_6_rt_c_tsk_c_msg_scene_skip_cfm : 'Confirm skip to ',

        p3_te_ztbj_theme_name : 'ThemeName',
        p3_te_ztbj_fuzzy_query : 'Keyword fuzzy query',
        p3_te_ztbj_query : 'Query',
        p3_te_ztbj_new : 'New',
        p3_te_ztbj_ide_config : 'IDE config',
        p3_te_ztbj_show_number : 'Show number',
        p3_te_ztbj_shs_ipt_list : 'Show action list number',
        p3_te_ztbj_auto_name : 'Auto name',
        p3_te_ztbj_show_auto_name : 'Checked, show auto name',
        p3_te_ztbj_lbl_done : 'Done',
        p3_te_ztbj_lbl_edit : 'Edit',
        p3_te_ztbj_lbl_name : 'Name',
        p3_te_ztbj_lbl_description : 'Description',
        p3_te_ztbj_resrouce_code : 'Res Code',
        p3_te_ztbj_btn_cancel : 'Cancel',
        p3_te_ztbj_confirm : 'Confirm',
        p3_te_ztbj_btn_share : 'Share',
        p3_te_ztbj_pls_ipt_phone : 'Please input phone number',
        p3_te_ztbj_find : 'Find',
        p3_te_ztbj_btn_backup : 'BACKUP',
        p3_te_ztbj_btn_del : 'DEL',
        p3_te_ztbj_btn_cooperate : 'COOP',
        p3_te_ztbj_choose_date : 'Choose date',
        p3_te_ztbj_own_theme : 'Own theme',
        p3_te_ztbj_coop_theme : 'Coop Theme',
        p3_te_ztbj_invalid_phone_num : 'Incorrect phone num ',
        p3_te_ztbj_usr_n_found : 'User not found',
        p3_te_ztbj_inv_param : 'Invalid param',
        p3_te_ztbj_msg_share_success : 'Share success',
        p3_te_ztbj_msg_share_failed : 'Share failed',
        p3_te_ztbj_coop_success : 'Cooperate success',
        p3_te_ztbj_coop_fail : 'Cooperate failed',
        p3_te_ztbj_bk_theme_prompt : 'Backup theme?',
        p3_te_ztbj_prompt : 'Prompt',
        p3_te_ztbj_bk_success : 'Backup success',
        p3_te_ztbj_bk_failed : 'Backup failed',
        p3_te_ztbj_cfm_del : 'Confirm delete theme?',
        p3_te_ztbj_del_success : 'Delete theme success',
        p3_te_ztbj_dev_fail : 'Delete theme failed',
        p3_te_ztbj_create_success : 'Create theme success',
        p3_te_ztbj_mdf_t_info_success : 'Modify theme info success',
        p3_te_ztbj_mdf_t_info_fail : 'Modify theme info failed',
        p3_te_ztbj_dev_prop_empty : 'some devices has unfilled  prop',
        p3_te_ztbj_upd_confirm : 'Begin to upgrade config to lastest structure. Backup is recommended',
        p3_te_ztbj_chkbar_actbar_empty : 'some checkbar or actbar is empty',
        p3_te_ztbj_thm_upd_success : 'Theme config upgrade success',
        p3_te_ztbj_read_only : 'ReadOnly',
        p3_te_ztbj_lbl_owner : 'Owner',
        p3_te_ztbj_lbl_mod_time : 'Modify time',
        p3_te_ztbj_lbl_modify : 'Modify',
        p3_te_ztbj_lbl_dev_edit : 'Dev edit',
        p3_te_ztbj_lbl_thm_edit : 'Scene edit',
        p3_te_ztbj_lbl_task_edit : 'Task edit',
        p3_te_ztbj_lbl_upd_cfg : 'Upd config',
        p3_te_ztbj_lbl_mgn : 'Manage',
        p3_te_ztbj_lbl_ver : 'Version',
        p3_te_ztbj_share : 'Theme share',
        p3_te_ztbj_coop : 'Theme coop',
        p3_te_ztbj_valid_day : 'Validity Period (Days)',
        p3_te_ztbj_cooper : 'Coop',
        p3_te_ztbj_op : 'Operate',
        p3_te_ztbj_cooperate : 'COOP',


        
        p4_lgn_tt_siva_cloud : 'SivaTech Cloud',
        p4_lgn_tt_pwd_lgn : 'Password',
        p4_lgn_tt_username : 'Username',
        p4_lgn_tt_passowrd : 'Passowrd',
        p4_lgn_tt_login : 'Login',
        p4_lgn_tt_sms_lgn : 'SMS code',
        p4_lgn_tt_phone : 'Phone',
        p4_lgn_cap_pwd_lgn : 'SMS Code',
        p4_lgn_tt_sec_to : ' sec to get SMS',
        p4_lgn_tt_veri_code : 'Get SMS',
        p4_lgn_tt_country_code : 'Country code',

        p4_um_title : 'User Management',
        p4_um_btn_add_user : 'Add User',
        p4_um_filter_username : 'Enter username',
        p4_um_loading : 'Loading',
        p4_um_col_no : 'No.',
        p4_um_empty_login : 'No login sessions',
        p4_um_col_login_time : 'Login Time',
        p4_um_col_login_ip : 'Login IP',
        p4_um_col_client_info : 'Client Info',
        p4_um_col_operation : 'Actions',
        p4_um_btn_logout_session : 'Sign out',
        p4_um_col_login_name : 'Login Name',
        p4_um_col_phone : 'Phone',
        p4_um_col_nickname : 'Nickname',
        p4_um_col_role : 'Role',
        p4_um_col_owner : 'Owner Admin',
        p4_um_col_status : 'Status',
        p4_um_status_normal : 'Active',
        p4_um_status_disabled : 'Disabled',
        p4_um_col_remark : 'Remark',
        p4_um_btn_edit : 'Edit',
        p4_um_btn_reset_pwd : 'Reset Password',
        p4_um_btn_delete : 'Delete',
        p4_um_dialog_user_info : 'User Info',
        p4_um_dialog_user_edit : 'Edit User',
        p4_um_label_account_role : 'Account Role',
        p4_um_placeholder_role : 'Select account role',
        p4_um_label_owner : 'Owner Admin',
        p4_um_placeholder_owner : 'Select owner admin',
        p4_um_label_login_name : 'Login Name',
        p4_um_label_nickname : 'Nickname',
        p4_um_label_password : 'Login Password',
        p4_um_label_confirm_password : 'Confirm Password',
        p4_um_label_phone : 'Phone Number',
        p4_um_placeholder_country_code : 'Code',
        p4_um_phone_placeholder : 'Enter phone number',
        p4_um_placeholder_keep_pwd : 'Leave blank to keep current password',
        p4_um_label_remark : 'Remark',
        p4_um_placeholder_remark : 'Enter remark',
        p4_um_btn_cancel : 'Cancel',
        p4_um_btn_confirm : 'OK',
        p4_um_dialog_delete_title : 'Confirm Delete',
        p4_um_dialog_delete_msg : 'Confirm deleting this user? The account cannot log in after deletion.',
        p4_um_role_sivaadmin : 'System Admin',
        p4_um_role_subadmin : 'Sub Admin',
        p4_um_role_koradmin : 'Korea Admin',
        p4_um_role_staff : 'Staff',
        p4_um_role_user : 'Regular User',
        p4_um_msg_delete_success : 'User deleted successfully',
        p4_um_msg_delete_failed : 'Failed to delete user',
        p4_um_msg_login_name_empty : 'Login name is empty',
        p4_um_msg_select_owner : 'Please select owner admin',
        p4_um_msg_phone_empty : 'Phone number is empty',
        p4_um_msg_pwd_not_match : 'The two passwords do not match',
        p4_um_msg_pwd_too_short : 'Password must be at least 6 characters',
        p4_um_msg_update_success : 'User updated successfully',
        p4_um_msg_update_failed : 'Failed to update user',
        p4_um_msg_add_success : 'User added successfully',
        p4_um_msg_add_failed : 'Failed to add user',
        p4_um_msg_session_logout_success : 'User session signed out successfully',
        p4_um_msg_session_logout_failed : 'Failed to sign out user session',

        p5_te_dev_lbl_thm_name : 'Theme',
        p5_te_dev_lbl_add : 'Add',
        p5_te_dev_lbl_finish : 'Finish',
        p5_te_dev_tt_iogrp_edit : 'IO Grp edit',
        p5_te_dev_lbl_name : 'Name',
        p5_te_dev_lbl_work_mode : 'Work mode',
        p5_te_dev_lbl_pls_choose : 'Pls chooese',
        p5_te_dev_lbl_edit : 'Edit',
        p5_te_dev_tt_ipt_edit : 'Input edit',
        p5_te_dev_lbl_sec : 'Sec',
        p5_te_dev_tt_opt_edit : 'Output edit',
        p5_te_dev_lbl_ms : 'MS',
        p5_te_dev_lbl_down_2_brd : 'Push config',
        p5_te_dev_btn_save : 'Save',
        p5_te_dev_btn_push : 'Push',
        p5_te_dev_lbl_cfm_push_theme : 'Confirm to push theme config',
        p5_te_dev_lbl_2_board : 'to board',
        p5_te_dev_btn_cancel : 'Cancel',
        p5_te_dev_btn_confirm : 'OK',
        p5_te_dev_lbl_thm_id : 'ThemeID',
        p5_te_dev_lbl_res_code : 'Res code',
        p5_te_dev_lbl_svr_mode : '(Used for media playback in server mode)',
        p5_te_dev_lbl_note : 'Note',
        p5_te_dev_btn_theme_list : 'Base Info',
        p5_te_dev_btn_scene_edit : 'Scene edit',
        p5_te_dev_tt_dev_order_set : 'Adj dev order',
        p5_te_dev_btn_new_dev : 'New dev',
        p5_te_dev_btn_help : 'Help',
        p5_te_dev_btn_order : 'Order',
        p5_te_dev_btn_export : 'Dev info Export',
        p5_te_dev_lbl_loading : 'Loading',
        p5_te_dev_lbl_number : 'No.',
        p5_te_dev_lbl_name : 'Name',
        p5_te_dev_lbl_dev_edit : 'Dev edit',
        p5_te_dev_tt_base_info : 'Basic Info',
        p5_te_dev_lbl_note : 'Note',
        p5_te_dev_tt_cfg_info : 'Config Info',
        p5_te_dev_tt_dev_export : 'Device export',
        p5_te_dev_lbl_category : 'Category',
        p5_te_dev_lbl_netdev : 'Net dev',
        p5_te_dev_lbl_port_no : 'Port No.',
        p5_te_dev_lbl_input_port_output : 'Output from input ports',
        p5_te_dev_hint_input_port_output : 'Generate output ports in input order by adding 1024 to each input port number',
        p5_te_dev_lbl_open_port : 'Open Port',
        p5_te_dev_lbl_close_port : 'Close Port',
        p5_te_dev_lbl_file_no : 'File No.',
        p5_te_dev_tt_cfm_push : 'Confirm to push',
        p5_te_dev_lbl_pls_enter : 'Please enter',
        p5_te_dev_lbl_ro : 'RO',
        p5_te_dev_btn_do_export : 'Export',
        p5_te_dev_lbl_pls_sel_bd : 'Pls select board',
        p5_te_dev_msg_ro_no_saving : 'Readonly mode, jump without saving',
        p5_te_dev_msg_empty_condition_err : 'The current scene has empty condition column or action column, please fill in or delete it',
        p5_te_dev_msg_auto_save_ok : 'Auto save successful',
        p5_te_dev_msg_auto_save_fail : 'Auto save failed',
        p5_te_dev_msg_brd_lst_refresh : 'Board list refreshed',
        p5_te_dev_msg_fail_obt_blist : 'Failed to obtain board list',
        p5_te_dev_msg_cp_success : 'Copy successful',
        p5_te_dev_msg_cp_scn_first : 'Please copy the scene first',
        p5_te_dev_msg_paste_ok : 'Paste successfully',
        p5_te_dev_msg_empty_list : 'Empty list',
        p5_te_dev_msg_cfg_del_scn : 'Are you sure you want to delete this scene?',
        p5_te_dev_lbl_pinyin_search : 'Supports Pinyin search',
        p5_te_dev_lbl_total : 'Total',
        p5_te_dev_lbl_devices : 'devices',
        p5_te_dev_msg_port_limit : 'Add failed: reached the maximum count',
        p5_te_dev_msg_dup_netdev_id : 'Duplicate network device ID',
        p5_te_dev_msg_issue_auth_expired : 'Issue failed: cloud platform permission has expired',
        p5_te_dev_msg_issue_started : 'Configuration download started',
        p5_te_dev_msg_issue_fail : 'Issue failed:',
        p5_te_dev_cfm_del_sel_dev : 'Are you sure you want to delete the selected device?',
        p5_te_dev_msg_del_dev_success : 'Device deleted successfully',
        p5_te_dev_msg_del_dev_used : 'This device is used in scene editing and cannot be deleted',
        p5_te_dev_msg_del_dev_fail : 'Delete device failed',
        p5_te_dev_lbl_device_manager : 'Device management',
        p5_te_dev_lbl_device_summary : 'Configuration',


        p6_te_scn_lbl_dev_edit : 'Dev edit',
        p6_te_scn_lbl_new_scn : 'New scene',
        p6_te_scn_lbl_dev_name : 'Dev name',
        p6_te_scn_lbl_entr_kw : 'Pls enter keyword',
        p6_te_scn_btn_search : 'Search',
        p6_te_scn_btn_export : 'Export',
        p6_te_scn_btn_export_xmind : 'Export Mind Map',
        p6_te_scn_lbl_next_scn : 'Next scene',
        p6_te_scn_lbl_delay_check : 'Postponed Latency(Sec)',

        // p6_te_scn_lbl_delay_check : 'Check Latency(Sec)',
        p6_te_scn_lbl_tae : 'TAE',
        p6_te_scn_lbl_timeout_sec : 'Timeout(Sec)',
        p6_te_scn_lbl_pass_chk_condition : 'Pass Condition',
        p6_te_scn_lbl_pass_condition : 'Pass Condition',
        p6_te_scn_lbl_entr_kw2 : 'Pls enter keyword',
        p6_te_scn_lbl_del_condition : 'Del',
        p6_te_scn_lbl_add_check_grp : 'Add check group',
        p6_te_scn_lbl_add_check_unt : 'Add check unit',
        p6_te_scn_lbl_inprogress_action : 'Inprogress actions',
        p6_te_scn_lbl_inprogress_eff : 'Inprogress effects',
        p6_te_scn_lbl_del_effects : 'Del',
        p6_te_scn_lbl_copy_effects : 'Copy',
        p6_te_scn_lbl_condition : 'Condition',
        p6_te_scn_lbl_success : 'Success',
        p6_te_scn_lbl_fail : 'Fail',
        p6_te_scn_lbl_add_inpgs_ca : 'Add inprogress check actions',
        p6_te_scn_lbl_paste_inpgs_ca : 'Paste copied actions (conditional)',
        p6_te_scn_lbl_onfinish_actions : 'On-finish actions',
        p6_te_scn_lbl_add_of_a_uc : 'Add on-finish actions (unconditional)',
        p6_te_scn_lbl_paste_of_a_uc : 'Paste copied on-finish actions (unconditional)',
        p6_te_scn_lbl_of_a_cdt : 'On-finish actions(conditional)',
        p6_te_scn_lbl_add_of_a_cdt : 'Add clearance action (conditional)',
        p6_te_scn_lbl_cp_action_cdt : 'Paste copied action (conditional)',
        audio_beat_theme_edit: 'Theme edit',
        audio_beat_scene_edit: 'Scene edit',
        audio_beat_title: 'Audio beat points',
        audio_beat_current_scene: 'Current scene',
        audio_beat_back_to_scene_edit: 'Back to scene editor',
        audio_beat_no_audio: 'No audio selected',
        audio_beat_choose_audio: 'Choose audio',
        audio_beat_pause: 'Pause',
        audio_beat_play: 'Play',
        audio_beat_back_to_start: 'Back to start',
        audio_beat_timeline: 'Timeline',
        audio_beat_zoom_out: 'Zoom out timeline',
        audio_beat_zoom_in: 'Zoom in timeline',
        audio_beat_fit_timeline: 'Fit',
        audio_beat_reselect_audio: 'Choose again',
        audio_beat_timeline_heading: 'Audio and completion actions',
        audio_beat_timeline_help: 'Drag empty space to pan; drag an action bar to change its trigger time',
        audio_beat_undo_move: 'Undo move',
        audio_beat_redo_move: 'Redo move',
        audio_beat_lock_action_drag: 'Lock action bar dragging',
        audio_beat_waveform: 'Waveform',
        audio_beat_action_bars: 'Completion action bars',
        audio_beat_undo_this_move: 'Undo this move',
        audio_beat_action_bar_count: '{count} action bar | {count} action bars',
        audio_beat_action_unit_count: '{count} action unit | {count} action units',
        audio_beat_add_action_at_time: 'Add action bar at current time',
        audio_beat_delete_action_bar: 'Delete action bar',
        audio_beat_no_action_bars: 'No action bars',
        audio_beat_action_bar_edit: 'Edit action bar',
        audio_beat_name: 'Name',
        audio_beat_action_bar_name: 'Action bar name',
        audio_beat_condition: 'Condition',
        audio_beat_check_action_help: 'Edit the CheckAction trigger condition',
        audio_beat_add_condition_group: 'Add condition group',
        audio_beat_edit_branch: 'Edit branch',
        audio_beat_action_units: 'Action units',
        audio_beat_action_unit_help: 'Uses the standard action bar editor and batch add',
        audio_beat_select_action_bar: 'Select an action bar',
        audio_beat_new_action_hint: 'New delay: {time}. The action bar will be shown on the timeline after creation.',
        audio_beat_unconditional_action: 'Unconditional action bar',
        audio_beat_conditional_action: 'Conditional action bar',
        audio_beat_success: 'Success',
        audio_beat_failure: 'Failure',
        audio_beat_load_failed: 'Load failed',
        audio_beat_loaded: 'Loaded',
        audio_beat_please_choose_audio: 'Please choose an audio file',
        audio_beat_saved_file_unreadable: 'The locally saved audio file could not be read. Please choose it again.',
        audio_beat_saved_file_missing: 'The saved content for audio file "{path}" was not found locally. Please choose it again.',
        audio_beat_local_save_failed: 'The audio works now but could not be saved locally. You will need to choose it again next time.',
        audio_beat_scene_id_missing: 'The current scene has no unique ID, so the audio cannot be restored next time.',
        audio_beat_load_error: 'Audio failed to load: the file is missing, unsupported, or corrupted. Please choose it again.',
        audio_beat_play_error: 'Audio playback failed. Please choose the audio file again.',
        audio_beat_default_action_name: 'Action bar {number}',
        audio_beat_action_bar: 'Action bar',
        audio_beat_keep_one_condition_group: 'Keep at least one condition group',
        audio_beat_action_limit: 'The number of completion action bars exceeds the limit ({limit}).',
        audio_beat_move_time: 'Time: {from} → {to}',
        audio_beat_select_scene_first: 'Please select a scene first',
        p6_te_scn_lbl_desc_txt : 'Description text',
        p6_te_scn_txt_cpoy_of : ' - copy',
        p6_te_scn_msg_manual_save_ok : 'Manual save successful',
        p6_te_scn_msg_manual_save_fail : 'Manual save failed',
        p6_te_scn_msg_last_no_del : 'The last scene cannot be deleted',
        p6_te_scn_lbl_and : 'AND',
        p6_te_scn_lbl_or : 'OR',
        p6_te_scn_lbl_add_au : 'Add action unit',
        p6_te_scn_lbl_mod_au : 'Modify action unit',
        p6_te_scn_lbl_param : 'param',
        p6_te_scn_lbl_batch_add_au : 'Batch add action',
        p6_te_scn_lbl_cp_al : 'Copy action list',
        p6_te_scn_lbl_dev_cate : 'Dev category',
        p6_te_scn_lbl_action : 'Action',
        p6_te_scn_msg_pls_sel_a : 'Pls select action',
        p6_te_scn_lbl_pass_con2 : 'Pass Condition:',
        p6_te_scn_lbl_of_actions2 : 'On finish action:',
        p6_te_scn_lbl_add_lu : 'Add logic unit',
        p6_te_scn_lbl_mod_lu : 'Modify logic unit',
        p6_te_scn_lbl_remove : ' ',
        p6_te_scn_lbl_add_to : ' ',
        p6_te_scn_lbl_tbs : 'Available',
        p6_te_scn_lbl_seled : 'Selected',
        p6_te_scn_lbl_batch_add : 'Batch add',
        p6_te_scn_lbl_pls_chs_or_keywd : 'Pls choose or entr keyword',
        p6_te_scn_lbl_selected : 'Selected',
        p6_te_scn_lbl_ports : 'ports',
        p6_te_scn_lbl_clear : 'Clear',
        p6_te_scn_lbl_port_sel : 'Port select',
        p6_te_scn_lbl_port_filter_placeholder : 'Enter port number or digits to filter (e.g. 1)',
        p6_te_scn_lbl_sel_ports : 'Sel Ports',
        p6_te_scn_lbl_clear_2 : 'Clear',
        p6_te_scn_lbl_clear_all : 'Clr ALL',
        p6_te_scn_lbl_pls_sel_wm : 'Pls sel workmode',
        p6_te_scn_txt_del_dev : 'Del device',
        p6_te_scn_msg_edit_tag_pending : 'Please finish the action tag that is being edited first',
        p6_te_scn_msg_dev_create_success : 'Device created successfully',
        p6_te_scn_msg_device_not_found : 'Device not found',

                

        p7_te_tsk_lbl_task : 'Task',
        p7_te_tsk_lbl_name : 'Name:',
        p7_te_tsk_lbl_entry_scn : 'Entry scene: ',
        p7_te_tsk_lbl_enable : 'ENABLED',
        p7_te_tsk_lbl_pls_sel_es : 'Pls select entry scene',

        // ===== p8: System Settings xtsz =====
        p8_xtsz_title : 'System Settings',
        p8_xtsz_lbl_nickname : 'Nickname',
        p8_xtsz_lbl_login_name : 'Login Name',
        p8_xtsz_lbl_phone : 'Phone',
        p8_xtsz_lbl_board_name : 'Board Name',
        p8_xtsz_lbl_show_limit : 'Show Limit',
        p8_xtsz_lbl_search_name : 'Search Name',
        p8_xtsz_lbl_own_board : 'My Boards',
        p8_xtsz_lbl_shared_board : 'Shared With Me',
        p8_xtsz_lbl_logged_client : 'Logged-in Clients',
        p8_xtsz_btn_edit : 'Edit',
        p8_xtsz_btn_search : 'Find',
        p8_xtsz_btn_share : 'Share',
        p8_xtsz_btn_rename : 'Rename',
        p8_xtsz_btn_transfer : 'Transfer',
        p8_xtsz_btn_delete : 'Delete',
        p8_xtsz_btn_cancel : 'Cancel',
        p8_xtsz_btn_confirm : 'OK',
        p8_xtsz_btn_logout : 'Logout',
        p8_xtsz_dlg_user_info : 'User Info',
        p8_xtsz_dlg_change_pwd : 'Change Password',
        p8_xtsz_dlg_login_pwd : 'Login Password',
        p8_xtsz_dlg_repeat_pwd : 'Confirm Password',
        p8_xtsz_dlg_board_transfer : 'Board Transfer',
        p8_xtsz_dlg_set_share : 'Set Share',
        p8_xtsz_dlg_delete_share : 'Delete Share',
        p8_xtsz_dlg_edit_board : 'Edit Board',
        p8_xtsz_dlg_board_limit : 'Board Show Limit',
        p8_xtsz_col_user : 'User',
        p8_xtsz_col_phone : 'Phone',
        p8_xtsz_col_validity : 'Valid Until',
        p8_xtsz_col_operation : 'Operation',
        p8_xtsz_col_name : 'Name',
        p8_xtsz_col_uid : 'UID',
        p8_xtsz_col_firmware : 'Firmware',
        p8_xtsz_col_status : 'Status',
        p8_xtsz_col_seq : 'No.',
        p8_xtsz_col_login_time : 'Login Time',
        p8_xtsz_col_login_ip : 'Login IP',
        p8_xtsz_col_client_info : 'Client Info',
        p8_xtsz_ph_area_code : 'Area Code',
        p8_xtsz_ph_keyword_query : 'Keyword query',
        p8_xtsz_ph_board_name : 'Enter board name',
        p8_xtsz_ph_show_limit_hint : '0 = No limit',
        p8_xtsz_ph_phone_input : 'Enter phone number',
        p8_xtsz_empty_no_share : 'No shares yet',
        p8_xtsz_empty_no_login : 'No login history',
        p8_xtsz_status_online : 'Online',
        p8_xtsz_status_offline : 'Offline',
        p8_xtsz_warn_transfer : 'After transfer, current user cannot operate. Please proceed with caution.',
        p8_xtsz_warn_delete_share : 'Confirm deleting share for this user?',
        p8_xtsz_warn_share_limit : 'Board already shared with over 10 users. Please clean up first.',
        p8_xtsz_msg_no_transfer_user : 'No transfer target user set',
        p8_xtsz_msg_transfer_success : 'Board transfer successful',
        p8_xtsz_msg_operation_failed : 'Operation failed',
        p8_xtsz_msg_board_edit_success : 'Board updated successfully',
        p8_xtsz_msg_limit_set_success : 'Show limit set successfully',
        p8_xtsz_msg_pwd_required : 'Enter the new password',
        p8_xtsz_msg_pwd_mismatch : 'Passwords do not match',
        p8_xtsz_msg_user_update_success : 'User updated successfully',
        p8_xtsz_msg_user_update_failed : 'Failed to update user',
        p8_xtsz_msg_phone_format_error : 'Invalid phone number',
        p8_xtsz_msg_user_not_found : 'User not found',
        p8_xtsz_lbl_user_prefix : 'User ',
        p8_xtsz_msg_no_share_user : 'No share target user set',
        p8_xtsz_msg_share_success : 'Share successful',
        p8_xtsz_msg_share_cancel_success : 'Share cancelled successfully',
        p8_xtsz_msg_share_info_updated : 'Share info updated',
        p8_xtsz_msg_get_share_info_failed : 'Failed to get share info',
        p8_xtsz_msg_token_remove_success : 'User session terminated',
        p8_xtsz_msg_token_remove_failed : 'Failed to terminate user session',
        p8_xtsz_ph_phone_placeholder : 'Enter phone number',

        dn_dt_1 : 'IO Grp',
        dn_dt_2 : 'Net dev',
        dn_dt_3 : 'Input',
        dn_dt_4 : 'Output',
        dn_dt_5 : 'Door/Lock',
        dn_dt_6 : 'Door',
        dn_dt_7 : 'Light',
        dn_dt_8 : 'AE',
        dn_dt_9 : 'TAE',
        dn_dt_10 : 'BGM',
        dn_dt_11 : 'Video',
        dn_dt_12 : 'Pic',
        dn_dt_13 : 'Net game',
        dn_dt_14 : 'Counter',
        dn_dt_30 : 'Task',
        dn_dt_31 : 'Force',
        dn_dt_32 : 'Skip',
        dn_dt_33 : 'Netdev rdy',
        dn_dt_34 : 'Prepared',
        dn_dt_35 : 'Start',
        dn_dt_36 : 'Finish',
        dn_dt_39 : 'Scene Effect',
        dn_dt_40 : 'Lang set',

        dn_dt_1_p1 : 'Work mode',
        dn_dt_1_p2 : 'Net module',
        dn_dt_1_p3 : 'Start port',
        dh_dt_1_p1 : 'External Modules: Multi-button panel, telephone. Others: Ports on the mainboard.',
        mn_dt_1_p1 : ['External module', 'Sequential btn', 'Sequential output', 'Beat output','Parallel Input', 'Series Input', 'Unordered Keys', 'Cyclic Keys', 'Key Count', 'Rhythm Judgment (Knocking)', 'Mole Mode', 'Memory Keys', 'Breathing Light Set', 'Multi-Card Seq Recognition','Rotary encoder', 'Digital input/output'],


        dn_dt_2_p1 : 'Search mode',
        dn_dt_2_p2 : 'Net dev ID',
        dn_dt_2_p3 : 'IP Address',
        dn_dt_2_p4 : 'IP Port',
        mn_dt_2_p1 : ['AUTO', 'Set IP/Port'],

        dn_dt_3_p1 : 'Work mode',
        dn_dt_3_p2 : 'Port num',
        dn_dt_3_p3 : 'Net module',
        dn_dt_3_p4 : 'Count',
        dn_dt_3_p5 : 'Delay(Sec)',
        // mn_dt_3_p1 : ['Normal', 'Button Pressed', 'Button Released', 'Trigger Count', 'Trigger Count (Timed)', 'Press Duration', 'Release Duration', 'Intermittent Press Duration', 'Inverted Signal', 'Process Reset', 'Multiple Card Recognition', 'Remote Control Reception'],
        mn_dt_3_p1 : ['Normal', 'Button Pressed', 'Button Released',
            'Trigger Count', 'Trigger Count (Timed)', 'Press Duration',
            'Release Duration', 'Intermittent Press Duration', 'Inverted Signal',
            'Process Reset', 'Multiple Card Recognition', 'Remote Control Reception','RESERVED','Out Port Follow','Timed Press Detection'],

        mn_dt_3_p1 : ['Normal', 'Button Pressed', 'Button Released', 'Trigger Count', 'Trigger Count (Timed)', 'Press Duration', 'Release Duration', 'Intermittent Press Duration', 'Inverted Signal', 'Process Reset', 'Multiple Card Recognition', 'Remote Control Reception'],
        dn_dt_4_p1 : 'Work mode',
        dn_dt_4_p2 : 'Port num',
        dn_dt_4_p3 : 'Net module',
        dn_dt_4_p4 : 'Count',
        dn_dt_4_p5 : 'Duty cycle(L)',
        dn_dt_4_p6 : 'Duty cycle(H)',
        dn_dt_4_p7 : 'ms-level control',
        dn_dt_4_p8 : 'Open duration',
        dn_dt_4_p9 : 'Close duration',
        dn_dt_4_p10 : 'Finish state',
        mn_dt_4_p1 : ['Normal', 'Loop', 'Random Loop', 'Preset Brightness', 'Fade In and Fade Out', 'Random Flashing', 'Breathing Effect', 'Retain', 'State Follow'],
        mn_dt_4_p2 : ['Off', 'On'],

        dn_dt_5_p1 : 'Work mode',
        dn_dt_5_p2 : 'Net module',
        dn_dt_5_p3 : 'Open port',
        dn_dt_5_p4 : 'Close port',
        dn_dt_5_p5 : 'Travel time (seconds)',
        mn_dt_5_p1 : ['Undefined', 'Electromagnetic lock (normally open)', 'Door closer (normally open)', 'Push rod motor', 'Electromagnetic lock (normally closed)', 'Door closer (normally closed)', 'Door closer with electromagnetic lock'],

        dn_dt_7_p1 : 'Port num',
        dn_dt_7_p2 : 'Duty cycle',

        dn_dt_8_p1 : 'File num',
        dn_dt_8_p2 : 'Net module',


        dn_dt_9_p1 : 'File num',
        dn_dt_9_p2 : 'Net module',
        dn_dt_9_p3 : 'Playback volume',

        dn_dt_10_p1 : 'File num',
        dn_dt_10_p2 : 'Net module',
        dn_dt_10_p3 : 'Playback volume',

        dn_dt_11_p1 : 'File num',
        dn_dt_11_p2 : 'Playback protocol',
        dn_dt_11_p3 : 'Net module',
        dn_dt_11_p4 : 'Video duration (seconds)',
        dn_dt_11_p5 : 'Playback address (filename)',
        dn_dt_11_p6 : 'Playback volume',
        dn_dt_11_p2_p1 : ['Regular (FILE/HTTP)', 'Real-time monitoring'],
        dh_dt_11_p1 : 'The filenames (including the number portion) stored on the USB drive connected to the STB.',
        dh_dt_11_p2 : 'The filename stored on the server.',

        dn_dt_12_p1 : 'Image file number',
        dn_dt_12_p2 : 'Net module',
        dn_dt_12_p3 : 'Playback address (filename)',
        dh_dt_12_p1 : 'The filenames (including the number portion) stored on the USB drive connected to the STB.',

        dn_dt_13_p1 : 'Net game ID',
        dn_dt_13_p2 : 'Net module',

        dn_dt_14_p1 : 'Work mode',
        dn_dt_14_p2 : 'Net module',
        mn_dt_14_p1 : ['Value', 'Timer'],

        p98_djcfg_sel_itm_local : 'Local',

        p97_devcfg_stn_dt_1 : ['FAIL','SUC','','','','','','','','','','','','','','','RUN'],
        p97_devcfg_stn_dt_2 : ['OFF', 'ONL'],
        p97_devcfg_stn_dt_3 : ['INV', 'VAL'],
        p97_devcfg_stn_dt_4 : ['CLSE', 'OPEN'],
        p97_devcfg_stn_dt_5 : ['OPEN', 'OPNG', 'CLOSE', 'CLSE'],
        p97_devcfg_stn_dt_7 : ['CLSE', 'OPEN'],
        p97_devcfg_stn_dt_6 : ['CLSE', 'OPEN'],
        p97_devcfg_stn_dt_8 : ['NORM', 'NORM'],
        p97_devcfg_stn_dt_10 : ['STOP', 'PLAY', 'STOP', 'PAUS'],
        p97_devcfg_stn_dt_11 : ['STOP', 'PLAY', 'STOP', 'PAUS'],
        p97_devcfg_stn_dt_12 : ['STOP', 'PLAY'],
        p97_devcfg_opn_dt_12_op_0 : 'STOP',
        p97_devcfg_opn_dt_12_op_1 : 'PLAY',
        p97_devcfg_stn_dt_13 : ['STOP', 'PLAY'],
        p97_devcfg_stn_dt_14 : ['STOP', 'PLAY'],
        p97_devcfg_opn_dt_1_op_0 : 'OFF',
        p97_devcfg_opn_dt_1_op_1 : 'ON',
        p97_devcfg_opn_dt_4_op_0 : 'OFF',
        p97_devcfg_opn_dt_4_op_1 : 'ON',
        p97_devcfg_opn_dt_5_op_0 : 'OPEN',
        p97_devcfg_opn_dt_5_op_1 : 'CLOS',
        p97_devcfg_opn_dt_7_op_0 : 'OFF',
        p97_devcfg_opn_dt_7_op_1 : 'ON',
        p97_devcfg_opn_dt_6_op_0 : 'CLOS',
        p97_devcfg_opn_dt_6_op_1 : 'OPEN',
        p97_devcfg_opn_dt_8_op_1 : 'PLAY',
        p97_devcfg_opn_dt_10_op_1 : 'PLAY',
        p97_devcfg_opn_dt_10_op_3 : 'PAUS',
        p97_devcfg_opn_dt_10_op_2 : 'RESM',
        p97_devcfg_opn_dt_10_op_0 : 'STOP',
        p97_devcfg_opn_dt_11_op_1 : 'PLAY',
        p97_devcfg_opn_dt_11_op_2 : 'RESM',
        p97_devcfg_opn_dt_11_op_3 : 'STOP',
        p97_devcfg_opn_dt_11_op_0 : 'STOP',
        p97_devcfg_opn_dt_13_op_1 : 'START',
        p97_devcfg_opn_dt_13_op_0 : 'STOP',

        dh_dt_1_p12 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_dt_1_p13 : 'Sound effect number to play automatically on success. 0 = do not play',
        hc_dt_1 : '<h3>External multi-key modules, telephones, or multiple input/output ports on the main board</h3><br/>  <p><li>Work mode<ul><li>External module: you need to configure Signal 1 (DA) port and Signal 2 (CK) port<br/>    <ul>      <li>Signal 1 (DA) port: result port</li>      <li>Signal 2 (CK) port: trigger port</li>    </ul>    </li><br/>  <li>Sequential keys: add (check) main board ports in sequence. When these ports are triggered in sequence, the port group outputs a correct signal</li></br>  <li>Sequential output: in the output port list, add main board output ports in sequence. These ports will light up one by one<br/>    <ul>      <li>Start port: the time each port stays lit (1 = 0.1 second)</li>      <li>Stop port: the time each port stays off (1 = 0.1 second)</li>      <li>Signal 1 (DA) port: control whether the port turns off, 0 = turns off, 1 = does not turn off</li>      <li>Signal 2 (CK) port: loop control, 0 = loop, 1 = no loop</li>    </ul>    </li></br>  <li>Parallel input: in the output port list, add main board input ports. When any one of these ports is triggered, the port group outputs a correct signal</li></br>  <li>Serial input: in the output port list, add main board input ports. When any one of these ports is triggered, the port group outputs a correct signal</li></br>  <li>Unordered keys: in the output port list, add main board input ports. After all of these ports have been triggered, the port group outputs a correct signal</li></br>  <li>Loop keys: in the output port list, add main board input ports in sequence. When these ports are triggered in sequence, the port group outputs a correct signal. No error signal is output</li></br>  <li>Key count: in the output port list, add main board input ports in sequence; in the output port list, fill in how many times each port should be pressed</br>    After these ports are pressed the specified number of times, the port group outputs a correct signal.</li></br>  <li>Breathing light group: in the output port list, add the ports that need to participate in the breathing effect;</br>    <ul>      <li>Breathing speed: the higher the value, the slower the breathing</li>      <li>Time to stay at the brightest and darkest levels</li>      <li>Maximum brightness: the maximum brightness of the light, 1-100</li>    </ul></li></br>  <li>Multi-card sequence recognition: determine the IC card numbers sensed in sequence, and pass when the sequence matches</br>    <ul>      <li>Breathing speed: the higher the value, the slower the breathing</li>      <li>Time to stay at the brightest and darkest levels</li>      <li>Answer list: add the card numbers to be swiped in sequence</li>    </ul>  </li></br>  </li></p>',
        hc_dt_10 : '<h3>Background audio</h3><br/>  <span>After background audio starts playing, it enters loop playback mode. Local mode (U disk or TF card)<br/>and network mode (through the audio set-top box) are supported</span>  <p><li>File number<ul><li>The sound effect corresponds to a file number. Files are named on the U disk or server as number.mp3.<br/>  For example, 001.mp3, 002.mp3</li><br/>  </li></p>  ',
        hc_dt_11 : '<h3>Video</h3><br/>  <span>Video supports local mode (playing video files in the U disk on the set-top box)<br/>  and network mode (playing video files on the store server)</span>    <li>File number: in local mode, the file number corresponding to the video in the U disk. The file is named<br/>        number.mp4. For example, 001.mp4, 002.mp4</li>    <li>Playback protocol    <ul><li>Normal: play ordinary video files</li>    <li>Real-time monitoring: play the real-time picture of surveillance cameras on the local area network</li>    </ul></li>  <li>Set-top box number: used to specify the set-top box that plays this video.</li>  <li>Video length: when playing a file, used to specify the duration to be played (it should be shorter than the duration of the file itself).</li>  <li>Playback address: in network mode, the video path on the server. If the full path is:<br/>http://192.168.1.100/HYZG/videos/001.mp4  then enter 001.mp4 here</li>  ',
        hc_dt_14 : '<h3>Counter</h3><br/>  <p><li>Stores values and can be used for numeric calculation and judgment<br/></li></p>  <p><li>Second-level timer, can be used for second-level timing<br/></li></p>',
        hc_dt_2 : '<h3>Set-top boxes, printers, etc.</h3><br/>  <p><li>Discovery mode<ul><li>Automatic discovery: through the internal device discovery protocol, network devices belonging to the main board theme can be discovered automatically</li><br/>  <li>Specify IP and port: configure the IP and port of the network device</li>  </li></p>',
        hc_dt_3 : '<h3>A single input port on the main board</h3><br/>  <p><li>Work mode<ul><li>Normal: triggered when the port has a valid level</li><br/>  <li>Key pressed: triggered once when the key is pressed</li><br/>  <li>Key released: triggered once when the key is released</li><br/>  <li>Trigger count: triggered once when the port has been triggered the specified number of times</li><br/>  <li>Press duration: triggered once after the port has been continuously triggered for the specified duration</li><br/>  <li>Release duration: triggered once after the port has continuously not been triggered for the specified duration</li><br/>  <li>Inverted signal: triggered when the port does not have a valid level, generally used for mechanisms that detect the output electromagnetic lock signal</li><br/>  <li>Flow reset: when the key is pressed, the flow is reset</li><br/>  </li></p>',
        hc_dt_4 : '<h3>A single output port on the main board</h3><br/>  <p><li>Work mode<ul><li>Normal: on = relay closed, off = relay open</li><br/>  <li>Loop: after starting, the relay works the specified number of times. In each cycle, the closed and open durations are configured through<br/>“On duration” and “Off duration”, and the number of times is configured through “Count”<br/>  After execution is completed, the ending state can be on (relay closed) or off (relay open), configured by “End state”</li><br/>  <li>Preset brightness: only valid on V5 hardware. On = output PWM according to the preset value, off = completely disconnected</li><br/>  <li>Fade in and out: only valid on V5 hardware. On = gradually increase from 0 to the preset value, the transition duration is controlled by “On duration”<br/>Off = gradually decrease from the preset value to complete disconnection. The transition duration is controlled by “Off duration”</li><br/>  <li>Random flashing: only valid on V5 hardware PWM boards. On = brightness changes randomly, the change speed is controlled by “On duration”, and the off duration is controlled by “Off duration”<br/>Off = turns off immediately</li><br/>  <li>Breathing effect: only valid on V5 hardware PWM boards. On = brightness changes evenly, the change speed is controlled by “On duration”<br/>Off = turns off immediately</li><br/>  <li>Status follow: on = follow the state of the input port, the input port number is specified by “Count”<br/>Off = stop following the state</li><br/>  </li></p>',
        hc_dt_5 : '<h3>Various types of doors</h3><br/>  <p><li>Work mode<ul><li>Electromagnetic lock (normally open): the electromagnetic lock is connected to the normally open terminal and is controlled by the “Open door port”. In the closed-door state, the port relay is closed</li><br/>  <li>Door closer: controlled by the “Open door port”. In the closed-door state, the port relay is closed</li><br/>  <li>Push-rod motor: controlled by the “Open door port” and “Close door port”.    <br/>In the closed-door state, the close-door port relay is closed for “Close delay” seconds (if the delay is 0, it stays closed all the time)    <br/>In the open-door state, the open-door port relay is closed for “Open delay” seconds (if the delay is 0, it stays closed all the time)</li><br/>  <li>Electromagnetic lock (normally closed): the electromagnetic lock is connected to the normally closed terminal and is controlled by the “Open door port”. In the closed-door state, the port relay is open</li><br/>  <li>Door closer with electromagnetic lock: the door closer is controlled by the “Open door port”. In the closed-door state, the port relay is open<br/>  The electromagnetic lock is controlled by the “Close door port”. In the closed-door state, the port relay is closed</li><br/>  </li></p>',
        hc_dt_7 : '<h3>Light device</h3><br/>  <p><li>Port number<ul><li>The power supply of the light is controlled by the “Port”. When the light is on, the relay of the corresponding port is closed</li><br/>  </li></p>',
        hc_dt_8 : '<h3>Sound effect</h3><br/>  <span>Sound effects support local mode (U disk or TF card) and network mode (through the audio set-top box)</span>  <p><li>File number<ul><li>The sound effect corresponds to a file number. Files are named on the U disk or server as number.mp3.<br/>  For example, 001.mp3, 002.mp3</li><br/>  </li></p>  <p><li>Set-top box number<ul><li>Used to specify the set-top box that plays this sound effect.</li><br/>  </li></p>',
        mn_dt_1_p10 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        mn_dt_1_p8 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        dh_ip_w10_count_b0_0 : 'Linked counter',
        dh_ip_w11_count_b0_0 : 'Linked counter',
        dh_ip_w2_count_b0_0 : 'Linked counter',
        dh_ip_w3_count_b0_0 : 'Trigger after this many presses',
        dh_ip_w4_count_b0_0 : 'Trigger after this many presses',
        dn_ip_w0_device_io_b0_0 : 'Port num',
        dn_ip_w1_device_io_b0_0 : 'Port num',
        dn_ip_w10_count_b0_0 : 'Counter',
        dn_ip_w10_device_io_b0_0 : 'Port num',
        dn_ip_w11_count_b0_0 : 'Counter',
        dn_ip_w11_device_io_b0_0 : 'Port num',
        dn_ip_w2_count_b0_0 : 'Counter',
        dn_ip_w2_device_io_b0_0 : 'Port num',
        dn_ip_w3_count_b0_0 : 'Press count',
        dn_ip_w3_device_io_b0_0 : 'Port num',
        dn_ip_w4_count_b0_0 : 'Press count',
        dn_ip_w4_device_io_b0_0 : 'Port num',
        dn_ip_w4_interval_b0_0 : 'Time limit (sec)',
        dn_ip_w5_device_io_b0_0 : 'Port num',
        dn_ip_w5_interval_b0_0 : 'Time limit (sec)',
        dn_ip_w6_device_io_b0_0 : 'Port num',
        dn_ip_w6_interval_b0_0 : 'Time limit (sec)',
        dn_ip_w7_device_io_b0_0 : 'Port num',
        dn_ip_w7_interval_b0_0 : 'Time limit (sec)',
        dn_ip_w8_device_io_b0_0 : 'Port num',
        dn_ip_w9_device_io_b0_0 : 'Port num',
        wm_ip_w0 : 'Normal',
        wm_ip_w1 : 'Key pressed',
        wm_ip_w10 : 'Multi-card recognition',
        wm_ip_w11 : 'Remote control receive',
        wm_ip_w2 : 'Key released',
        wm_ip_w3 : 'Trigger count',
        wm_ip_w4 : 'Trigger count (timed)',
        wm_ip_w5 : 'Press duration',
        wm_ip_w6 : 'Release duration',
        wm_ip_w7 : 'Intermittent press duration',
        wm_ip_w8 : 'Inverted signal',
        wm_ip_w9 : 'Flow reset',
        at_iog_w10_result_io_b12_12 : 'Yes',
        at_iog_w2_ck_io_b0_2 : 'Single output',
        at_iog_w2_ck_io_b3_3 : 'On',
        at_iog_w2_result_io_b0_0 : 'Stay on after lighting',
        dh_iog_w0_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w0_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w1_fail_wait_b0_0 : 'Wait time before restart after failure (cooldown)',
        dh_iog_w1_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w1_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w1_start_io_b0_2 : '0 normal, 1 single key, 2 inverted signal',
        dh_iog_w1_start_io_b13_13 : 'Remove duplicate key presses',
        dh_iog_w1_start_io_b14_15 : '0 disabled; 1 keys valid when output port is active; 2 keys valid when output port is inactive',
        dh_iog_w1_start_io_b3_5 : '0 no light, 1 light on press, 2 stay lit after press, 3 turn off on press, 4 stay off after press, 5 stay lit after press (not auto-lit), 6 stay off after press (not auto-lit)',
        dh_iog_w1_start_io_b6_6 : 'Judge at any time without waiting for all key presses; output error on mistake',
        dh_iog_w1_start_io_b8_12 : '0 judge all; 1-16 judge only the first 1-16 keys',
        dh_iog_w10_ck_io_b0_7 : 'Counter that records successful hits; 0 none, 1-255 counter number',
        dh_iog_w10_input_io_list_b0_0 : 'Key port number',
        dh_iog_w10_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w10_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w10_output_io_list_b0_0 : 'Port number for key light',
        dh_iog_w10_result_io_b11_11 : 'Output failure message and stop the current round after failure',
        dh_iog_w10_result_io_b12_12 : 'Whether to deduct points on error; 0 No, 1 Yes',
        dh_iog_w10_start_io_b0_0 : 'Whether the success count accumulates; if not, success must be consecutive to pass',
        dh_iog_w10_start_io_b1_5 : 'Required success count to pass (max 31)',
        dh_iog_w10_start_io_b12_15 : 'Number of lights shown per round; 0 random, 1-15 as upper limit',
        dh_iog_w10_start_io_b6_11 : 'Larger value means lower difficulty, max 60',
        dh_iog_w10_stop_io_b0_4 : 'Flash after a single error; 0 no flash, 1-30 flash count',
        dh_iog_w11_input_io_list_b0_0 : 'Key port number',
        dh_iog_w11_output_io_list_b0_0 : 'Port number for key light',
        dh_iog_w11_result_io_b8_15 : 'Restart interval after failure (sec)',
        dh_iog_w11_start_io_b0_5 : 'Maximum quantity to memorize',
        dh_iog_w11_start_io_b11_15 : 'Off duration between puzzles (0.1-3 s)',
        dh_iog_w11_start_io_b6_10 : 'Lighting duration for each puzzle (0.1-3 s)',
        dh_iog_w11_stop_io_b0_10 : 'Maximum answer time limit 1-100 sec',
        dh_iog_w11_stop_io_b11_13 : 'Whether keys follow the lit lights during answering',
        dh_iog_w11_stop_io_b14_14 : 'End the current round immediately and output failure on error',
        dh_iog_w12_ck_io_b6_10 : 'Maximum lamp brightness, 1-100',
        dh_iog_w12_fail_wait_b0_15 : 'Breathing speed; larger value means slower breathing',
        dh_iog_w12_output_io_list_b0_0 : 'Lamp port number',
        dh_iog_w12_result_io_b11_15 : 'Hold time at brightest and darkest states',
        dh_iog_w13_fail_wait_b0_0 : 'Wait time before restart after failure (cooldown)',
        dh_iog_w13_input_io_list_b0_0 : 'Input port connected to the IC sensor (only one)',
        dh_iog_w13_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w13_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w13_output_io_list_b0_0 : 'Answer card number list',
        dh_iog_w13_start_io_b13_13 : 'Whether to remove duplicate card numbers (each round)',
        dh_iog_w13_start_io_b3_5 : '0 sequential mode, 1 loop mode',
        dh_iog_w13_start_io_b6_6 : 'Judge at any time without waiting for all key presses; output error on mistake (sequential mode only)',
        dh_iog_w13_start_io_b8_12 : '0 judge all; 1-16 judge only the first 1-16 answers (sequential mode only)',
        dh_iog_w14_ck_io_b0_5 : 'Number of accumulated encoder pulses before the value changes once',
        dh_iog_w14_input_io_list_b0_0 : 'Input ports connected to the sensor (only two)',
        dh_iog_w14_output_io_list_b0_0 : 'Output the current corresponding value on the output ports',
        dh_iog_w14_result_io_b0_7 : '0 unbound; other values are counter indexes',
        dh_iog_w14_result_io_b8_15 : 'When the value is adjusted to this number, the result is judged as success',
        dh_iog_w14_start_io_b0_2 : '0 direct output, 1 8421 code',
        dh_iog_w14_start_io_b3_4 : 'When the value reaches an end, it automatically wraps to the other end',
        dh_iog_w14_start_io_b5_6 : '0 normal installation, 1 reverse installation',
        dh_iog_w14_stop_io_b0_7 : 'When the value is adjusted to this number, the result is judged as success',
        dh_iog_w15_input_io_list_b0_0 : 'If input ports are configured, values are read from input ports and then output',
        dh_iog_w15_output_io_list_b0_0 : 'Output the current corresponding value on the output ports',
        dh_iog_w15_result_io_b0_7 : '0 unbound; other values are counter indexes',
        dh_iog_w15_result_io_b8_15 : 'When the value is adjusted to this number, the result is judged as success',
        dh_iog_w15_start_io_b0_2 : '0 direct output, 1 8421 code, 2 continuous port segment',
        dh_iog_w15_start_io_b3_5 : 'Input port read mode: 0 single-port active, 1 8421 code',
        dh_iog_w2_fail_wait_b0_0 : 'Loop interval time',
        dh_iog_w2_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w2_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w2_start_io_b0_0 : 'Duration that the port stays lit',
        dh_iog_w2_stop_io_b0_0 : 'Delay before the next port lights after the current port turns off',
        dh_iog_w3_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w3_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w4_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w4_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w5_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w5_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w6_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w6_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w7_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w7_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w7_start_io_b0_2 : '0 normal, 1 single key, 2 inverted signal',
        dh_iog_w8_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w8_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w8_start_io_b6_8 : '0 unordered, quantity only; 1 ordered, auto-restart on error; 2 ordered, output error immediately',
        dh_iog_w9_input_io_list_b0_0 : 'Fill only one',
        dh_iog_w9_on_fail_ae_b0_0 : 'Sound effect number to play automatically on failure. 0 = do not play',
        dh_iog_w9_on_success_ae_b0_0 : 'Sound effect number to play automatically on success. 0 = do not play',
        dh_iog_w9_start_io_b0_0 : 'Interval after continuous knocks; knocks beyond this time are counted as the next segment',
        dh_iog_w9_stop_io_b0_0 : 'Do not output an error signal until the final success',
        dn_iog_w0_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w0_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w0_input_io_count_b0_0 : 'Input port count',
        dn_iog_w0_input_io_list_b0_0 : 'Input port list',
        dn_iog_w0_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w0_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w0_output_io_count_b0_0 : 'Output port count',
        dn_iog_w0_output_io_list_b0_0 : 'Output port list',
        dn_iog_w0_result_io_b1_5 : 'Result port (signal 1)',
        dn_iog_w0_start_io_b0_0 : 'Start port',
        dn_iog_w0_stop_io_b0_0 : 'Stop port',
        dn_iog_w1_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w1_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w1_input_io_count_b0_0 : 'Input port count',
        dn_iog_w1_input_io_list_b0_0 : 'Input port list',
        dn_iog_w1_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w1_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w1_output_io_count_b0_0 : 'Output port count',
        dn_iog_w1_output_io_list_b0_0 : 'Output port list',
        dn_iog_w1_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w1_start_io_b0_2 : 'Key mode',
        dn_iog_w1_start_io_b13_13 : 'Remove duplicates',
        dn_iog_w1_start_io_b14_15 : 'Output binding',
        dn_iog_w1_start_io_b3_5 : 'Key light mode',
        dn_iog_w1_start_io_b6_6 : 'Continuous judgment',
        dn_iog_w1_start_io_b8_12 : 'Partial judgment',
        dn_iog_w1_stop_io_b0_0 : 'Input port list',
        dn_iog_w10_ck_io_b0_7 : 'Success counter',
        dn_iog_w10_fail_wait_b0_0 : 'Auto restart time',
        dn_iog_w10_input_io_count_b0_0 : 'Input port count',
        dn_iog_w10_input_io_list_b0_0 : 'Key ports',
        dn_iog_w10_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w10_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w10_output_io_count_b0_0 : 'Key light count',
        dn_iog_w10_output_io_list_b0_0 : 'Key light ports',
        dn_iog_w10_result_io_b10_10 : 'Specified light count',
        dn_iog_w10_result_io_b11_11 : 'Stop on error',
        dn_iog_w10_result_io_b12_12 : 'Deduct points on error',
        dn_iog_w10_start_io_b0_0 : 'Success accumulation',
        dn_iog_w10_start_io_b1_5 : 'Required success count',
        dn_iog_w10_start_io_b12_15 : 'Light count per question',
        dn_iog_w10_start_io_b6_11 : 'Difficulty factor',
        dn_iog_w10_stop_io_b0_4 : 'Flash on error',
        dn_iog_w10_stop_io_b11_15 : 'Restart interval',
        dn_iog_w10_stop_io_b5_9 : 'Flash interval on error',
        dn_iog_w11_input_io_count_b0_0 : 'Input port count',
        dn_iog_w11_input_io_list_b0_0 : 'Key ports',
        dn_iog_w11_output_io_count_b0_0 : 'Key light count',
        dn_iog_w11_output_io_list_b0_0 : 'Key light ports',
        dn_iog_w11_result_io_b8_15 : 'Restart interval',
        dn_iog_w11_start_io_b0_5 : 'Puzzle count',
        dn_iog_w11_start_io_b11_15 : 'Off duration',
        dn_iog_w11_start_io_b6_10 : 'Light-on duration',
        dn_iog_w11_stop_io_b0_10 : 'Answer time limit',
        dn_iog_w11_stop_io_b11_13 : 'Answer key lights',
        dn_iog_w11_stop_io_b14_14 : 'Output error immediately',
        dn_iog_w12_ck_io_b6_10 : 'Maximum brightness',
        dn_iog_w12_fail_wait_b0_15 : 'Breathing speed',
        dn_iog_w12_output_io_count_b0_0 : 'Key light count',
        dn_iog_w12_output_io_list_b0_0 : 'Lamp ports',
        dn_iog_w12_result_io_b11_15 : 'Dwell time',
        dn_iog_w13_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w13_input_io_count_b0_0 : 'Input port count',
        dn_iog_w13_input_io_list_b0_0 : 'Input',
        dn_iog_w13_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w13_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w13_output_io_count_b0_0 : 'Answer count',
        dn_iog_w13_output_io_list_b0_0 : 'Answer list',
        dn_iog_w13_start_io_b13_13 : 'Remove duplicates',
        dn_iog_w13_start_io_b3_5 : 'Judgment mode',
        dn_iog_w13_start_io_b6_6 : 'Continuous judgment in sequential mode',
        dn_iog_w13_start_io_b8_12 : 'Partial judgment in sequential mode',
        dn_iog_w14_ck_io_b0_5 : 'Pulses per step',
        dn_iog_w14_input_io_count_b0_0 : 'Input port count',
        dn_iog_w14_input_io_list_b0_0 : 'Input',
        dn_iog_w14_output_io_count_b0_0 : 'Output port count',
        dn_iog_w14_output_io_list_b0_0 : 'Output',
        dn_iog_w14_result_io_b0_7 : 'Bind counter',
        dn_iog_w14_result_io_b8_15 : 'Expected result',
        dn_iog_w14_start_io_b0_2 : 'Result output mode',
        dn_iog_w14_start_io_b3_4 : 'Loop adjustment',
        dn_iog_w14_start_io_b5_6 : 'Sensor direction',
        dn_iog_w14_stop_io_b0_7 : 'Value upper limit',
        dn_iog_w15_input_io_count_b0_0 : 'Input port count',
        dn_iog_w15_input_io_list_b0_0 : 'Input',
        dn_iog_w15_output_io_count_b0_0 : 'Output port count',
        dn_iog_w15_output_io_list_b0_0 : 'Output',
        dn_iog_w15_result_io_b0_7 : 'Bind counter',
        dn_iog_w15_result_io_b8_15 : 'Expected result',
        dn_iog_w15_start_io_b0_2 : 'Result output mode',
        dn_iog_w15_start_io_b3_5 : 'Input mode',
        dn_iog_w2_ck_io_b0_2 : 'Single output only',
        dn_iog_w2_ck_io_b3_3 : 'Random order',
        dn_iog_w2_fail_wait_b0_0 : 'Loop interval',
        dn_iog_w2_input_io_count_b0_0 : 'Input port count',
        dn_iog_w2_input_io_list_b0_0 : 'Input port list',
        dn_iog_w2_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w2_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w2_output_io_count_b0_0 : 'Output port count',
        dn_iog_w2_output_io_list_b0_0 : 'Output port list',
        dn_iog_w2_result_io_b0_0 : 'Keep lit',
        dn_iog_w2_start_io_b0_0 : 'Lighting time',
        dn_iog_w2_stop_io_b0_0 : 'Extinguish time',
        dn_iog_w3_input_io_count_b0_0 : 'Input port count',
        dn_iog_w3_input_io_list_b0_0 : 'Input port list',
        dn_iog_w3_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w3_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w3_output_io_count_b0_0 : 'Beat count',
        dn_iog_w3_output_io_list_b0_0 : 'Beat list',
        dn_iog_w3_result_io_b0_8 : 'Overall interval',
        dn_iog_w3_start_io_b0_12 : 'Port num',
        dn_iog_w3_start_io_b14_14 : 'Loop playback',
        dn_iog_w3_stop_io_b0_4 : 'Lighting time',
        dn_iog_w3_stop_io_b10_15 : 'Beat interval',
        dn_iog_w3_stop_io_b5_9 : 'Extinguish time',
        dn_iog_w4_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w4_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w4_input_io_count_b0_0 : 'Input port count',
        dn_iog_w4_input_io_list_b0_0 : 'Input port list',
        dn_iog_w4_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w4_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w4_output_io_count_b0_0 : 'Output port count',
        dn_iog_w4_output_io_list_b0_0 : 'Output port list',
        dn_iog_w4_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w4_start_io_b0_0 : 'Start port',
        dn_iog_w4_stop_io_b0_0 : 'Stop port',
        dn_iog_w5_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w5_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w5_input_io_count_b0_0 : 'Input port count',
        dn_iog_w5_input_io_list_b0_0 : 'Input port list',
        dn_iog_w5_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w5_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w5_output_io_count_b0_0 : 'Output port count',
        dn_iog_w5_output_io_list_b0_0 : 'Output port list',
        dn_iog_w5_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w5_start_io_b0_0 : 'Start port',
        dn_iog_w5_stop_io_b0_0 : 'Stop port',
        dn_iog_w6_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w6_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w6_input_io_count_b0_0 : 'Input port count',
        dn_iog_w6_input_io_list_b0_0 : 'Input port list',
        dn_iog_w6_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w6_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w6_output_io_count_b0_0 : 'Output port count',
        dn_iog_w6_output_io_list_b0_0 : 'Output port list',
        dn_iog_w6_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w6_start_io_b0_0 : 'Start port',
        dn_iog_w6_stop_io_b0_0 : 'Stop port',
        dn_iog_w7_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w7_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w7_input_io_count_b0_0 : 'Input port count',
        dn_iog_w7_input_io_list_b0_0 : 'Input port list',
        dn_iog_w7_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w7_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w7_output_io_count_b0_0 : 'Result count',
        dn_iog_w7_output_io_list_b0_0 : 'Result list',
        dn_iog_w7_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w7_start_io_b0_2 : 'Key mode',
        dn_iog_w7_stop_io_b0_0 : 'Stop port',
        dn_iog_w8_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w8_fail_wait_b0_0 : 'Failure wait',
        dn_iog_w8_input_io_count_b0_0 : 'Input port count',
        dn_iog_w8_input_io_list_b0_0 : 'Input port list',
        dn_iog_w8_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w8_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w8_output_io_count_b0_0 : 'Result count',
        dn_iog_w8_output_io_list_b0_0 : 'Result list',
        dn_iog_w8_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w8_start_io_b6_8 : 'Judgment mode',
        dn_iog_w8_stop_io_b0_0 : 'Stop port',
        dn_iog_w9_ck_io_b0_0 : 'Trigger port (signal 2)',
        dn_iog_w9_fail_wait_b0_0 : 'Auto restart time',
        dn_iog_w9_input_io_count_b0_0 : 'Input port count',
        dn_iog_w9_input_io_list_b0_0 : 'Input',
        dn_iog_w9_on_fail_ae_b0_0 : 'Failure sound effect',
        dn_iog_w9_on_success_ae_b0_0 : 'Success sound effect',
        dn_iog_w9_output_io_count_b0_0 : 'Rhythm group count',
        dn_iog_w9_output_io_list_b0_0 : 'Rhythm group list',
        dn_iog_w9_result_io_b0_0 : 'Result port (signal 1)',
        dn_iog_w9_start_io_b0_0 : 'Rhythm segment interval',
        dn_iog_w9_stop_io_b0_0 : 'Continuous judgment',
        ec_iog_w1_input_io_list : 'Port edit',
        ec_iog_w1_output_io_list : 'Port edit',
        ec_iog_w1_stop_io : 'Port edit',
        ec_iog_w10_input_io_list : 'Key port edit',
        ec_iog_w10_output_io_list : 'Lamp port edit',
        ec_iog_w11_input_io_list : 'Key port edit',
        ec_iog_w11_output_io_list : 'Lamp port edit',
        ec_iog_w12_output_io_list : 'Lamp port edit',
        ec_iog_w13_input_io_list : 'Port edit',
        ec_iog_w13_output_io_list : 'Port edit',
        ec_iog_w14_input_io_list : 'Port edit',
        ec_iog_w14_output_io_list : 'Port edit',
        ec_iog_w15_input_io_list : 'Port edit',
        ec_iog_w15_output_io_list : 'Port edit',
        ec_iog_w2_output_io_list : 'Port edit',
        ec_iog_w5_input_io_list : 'Port edit',
        ec_iog_w6_input_io_list : 'Port edit',
        ec_iog_w7_input_io_list : 'Port edit',
        ec_iog_w7_output_io_list : 'Port edit',
        ec_iog_w8_input_io_list : 'Port edit',
        ec_iog_w8_output_io_list : 'Result edit',
        ec_iog_w9_input_io_list : 'Port edit',
        ec_iog_w9_output_io_list : 'Result edit',
        ec_dt_1_p8 : 'Port edit',
        ei_dt_1_p8 : 'Port',
        ev_dt_1_p8 : 'Port No.',
        ec_dt_1_p10 : 'Port edit',
        ei_dt_1_p10 : 'Port',
        ev_dt_1_p10 : 'Port No.',
        ei_iog_w1_input_io_list : 'Port num',
        ei_iog_w1_output_io_list : 'Port num',
        ei_iog_w1_stop_io : 'Port num',
        ei_iog_w10_input_io_list : 'Port num',
        ei_iog_w10_output_io_list : 'Port num',
        ei_iog_w11_input_io_list : 'Port num',
        ei_iog_w11_output_io_list : 'Port num',
        ei_iog_w12_output_io_list : 'Port num',
        ei_iog_w13_input_io_list : 'Port num',
        ei_iog_w13_output_io_list : 'Answer',
        ei_iog_w14_input_io_list : 'Port num',
        ei_iog_w14_output_io_list : 'Port num',
        ei_iog_w15_input_io_list : 'Port num',
        ei_iog_w15_output_io_list : 'Port num',
        ei_iog_w2_output_io_list : 'Port num',
        ei_iog_w5_input_io_list : 'Port num',
        ei_iog_w6_input_io_list : 'Port num',
        ei_iog_w7_input_io_list : 'Port num',
        ei_iog_w7_output_io_list : 'Port num',
        ei_iog_w8_input_io_list : 'Port num',
        ei_iog_w8_output_io_list : 'Count',
        ei_iog_w9_input_io_list : 'Port num',
        ei_iog_w9_output_io_list : 'Knock count',
        ev_iog_w1_input_io_list : 'Port num',
        ev_iog_w1_output_io_list : 'Port num',
        ev_iog_w1_stop_io : 'Port num',
        ev_iog_w10_input_io_list : 'Port num',
        ev_iog_w10_output_io_list : 'Port num',
        ev_iog_w11_input_io_list : 'Port num',
        ev_iog_w11_output_io_list : 'Port num',
        ev_iog_w12_output_io_list : 'Port num',
        ev_iog_w13_input_io_list : 'Port num',
        ev_iog_w13_output_io_list : 'Answer card number',
        ev_iog_w14_input_io_list : 'Port num',
        ev_iog_w14_output_io_list : 'Port num',
        ev_iog_w15_input_io_list : 'Port num',
        ev_iog_w15_output_io_list : 'Port num',
        ev_iog_w2_output_io_list : 'Port num',
        ev_iog_w5_input_io_list : 'Port num',
        ev_iog_w6_input_io_list : 'Port num',
        ev_iog_w7_input_io_list : 'Port num',
        ev_iog_w7_output_io_list : 'Port num',
        ev_iog_w8_input_io_list : 'Port num',
        ev_iog_w8_output_io_list : 'Press count',
        ev_iog_w9_input_io_list : 'Port num',
        ev_iog_w9_output_io_list : 'Rhythm count',
        it_iog_w10_result_io_b12_12 : 'No',
        it_iog_w2_ck_io_b0_2 : 'Loop output',
        it_iog_w2_ck_io_b3_3 : 'Disabled',
        it_iog_w2_result_io_b0_0 : 'Turn off and light the next',
        wm_iog_w0 : 'External module',
        wm_iog_w1 : 'Sequential port group',
        wm_iog_w10 : 'Whack-a-mole game',
        wm_iog_w11 : 'Memory Keys',
        wm_iog_w12 : 'Breathing Light Set',
        wm_iog_w13 : 'Multi-Card Seq Recognition',
        wm_iog_w14 : 'Rotary encoder',
        wm_iog_w15 : 'Digital input/output',
        wm_iog_w2 : 'Sequential output',
        wm_iog_w3 : 'Beat output',
        wm_iog_w4 : 'Parallel Input',
        wm_iog_w5 : 'Series Input',
        wm_iog_w6 : 'Unordered Keys',
        wm_iog_w7 : 'Cyclic Keys',
        wm_iog_w8 : 'Cyclic Keys',
        wm_iog_w9 : 'Rhythm judgment',
        at_op_w1_finish_status_b0_0 : 'On',
        at_op_w1_ms_ctrl_b0_0 : 'MS',
        at_op_w2_finish_status_b0_0 : 'On',
        at_op_w4_finish_status_b0_0 : 'On',
        at_op_w6_finish_status_b0_0 : 'On',
        dh_op_w1_count_b0_0 : 'After reaching this count, stop looping and keep the port in the specified state',
        dh_op_w1_ms_ctrl_b0_0 : 'Unit of control precision',
        dh_op_w2_count_b0_0 : 'After reaching this count, stop looping and keep the port in the specified state',
        dh_op_w3_brightness_b0_0 : 'Brightness value when the port is on',
        dh_op_w4_brightness_b0_0 : 'Brightness value at the brightest state',
        dh_op_w4_brightness_low_b0_0 : 'Brightness value at the darkest state',
        dh_op_w4_interval1_b0_0 : 'Time to brighten; larger value means slower change',
        dh_op_w4_interval2_b0_0 : 'Time to dim; larger value means slower change',
        dh_op_w5_brightness_b0_0 : 'Brightness value at the brightest state',
        dh_op_w5_brightness_low_b0_0 : 'Brightness value at the darkest state',
        dh_op_w5_count_b0_0 : 'On-time ratio during flashing; larger value means a longer lit duration',
        dh_op_w5_interval1_b0_0 : 'Brightness change speed; larger value means slower',
        dh_op_w5_interval2_b0_0 : 'Off-hold duration; larger value means longer',
        dh_op_w6_brightness_b0_0 : 'Brightness value at the brightest state',
        dh_op_w6_brightness_low_b0_0 : 'Brightness value at the darkest state',
        dh_op_w6_interval1_b0_0 : 'Brightness change speed; larger value means slower',
        dh_op_w6_interval2_b0_0 : 'Hold time at brightest and darkest states; larger value means longer',
        dh_op_w8_count_b0_0 : 'Input port number to follow (1-200)',
        dn_op_w0_device_io_b0_0 : 'Port num',
        dn_op_w1_count_b0_0 : 'Loop count',
        dn_op_w1_device_io_b0_0 : 'Port num',
        dn_op_w1_finish_status_b0_0 : 'Finish state',
        dn_op_w1_interval1_b0_0 : 'Open duration',
        dn_op_w1_interval2_b0_0 : 'Close duration',
        dn_op_w1_ms_ctrl_b0_0 : 'ms-level control',
        dn_op_w2_count_b0_0 : 'Loop count',
        dn_op_w2_device_io_b0_0 : 'Port num',
        dn_op_w2_finish_status_b0_0 : 'Finish state',
        dn_op_w2_interval1_b0_0 : 'Open duration',
        dn_op_w2_interval2_b0_0 : 'Close duration',
        dn_op_w3_brightness_b0_0 : 'Duty cycle',
        dn_op_w3_device_io_b0_0 : 'Port num',
        dn_op_w4_brightness_b0_0 : 'Maximum brightness',
        dn_op_w4_brightness_low_b0_0 : 'Minimum brightness',
        dn_op_w4_device_io_b0_0 : 'Port num',
        dn_op_w4_finish_status_b0_0 : 'Finish state',
        dn_op_w4_interval1_b0_0 : 'Brighten duration',
        dn_op_w4_interval2_b0_0 : 'Dim duration',
        dn_op_w5_brightness_b0_0 : 'Maximum brightness',
        dn_op_w5_brightness_low_b0_0 : 'Minimum brightness',
        dn_op_w5_count_b0_0 : 'Flash interval',
        dn_op_w5_device_io_b0_0 : 'Port num',
        dn_op_w5_interval1_b0_0 : 'Change speed',
        dn_op_w5_interval2_b0_0 : 'Off duration',
        dn_op_w6_brightness_b0_0 : 'Maximum brightness',
        dn_op_w6_brightness_low_b0_0 : 'Minimum brightness',
        dn_op_w6_device_io_b0_0 : 'Port num',
        dn_op_w6_finish_status_b0_0 : 'Finish state',
        dn_op_w6_interval1_b0_0 : 'Change speed',
        dn_op_w6_interval2_b0_0 : 'Hold duration',
        dn_op_w7_device_io_b0_0 : 'Port num',
        dn_op_w8_count_b0_0 : 'Follow input port',
        dn_op_w8_device_io_b0_0 : 'Port num',
        it_op_w1_finish_status_b0_0 : 'Close',
        it_op_w1_ms_ctrl_b0_0 : 'Sec',
        it_op_w2_finish_status_b0_0 : 'Close',
        it_op_w4_finish_status_b0_0 : 'Close',
        it_op_w6_finish_status_b0_0 : 'Close',
        wm_op_w0 : 'Normal',
        wm_op_w1 : 'Loop',
        wm_op_w2 : 'Random Loop',
        wm_op_w3 : 'Preset Brightness',
        wm_op_w4 : 'Fade In and Fade Out',
        wm_op_w5 : 'Random Flashing',
        wm_op_w6 : 'Breathing Effect',
        wm_op_w7 : 'Retain',
        wm_op_w8 : 'State Follow',
        dh_dt_1_p2 : '',
        dh_dt_1_p3 : 'Leave blank if unused',
        dh_dt_1_p4 : 'Leave blank if unused',
        dh_dt_1_p5 : 'When using an external module, this is the main board port connected to Signal 1.',
        dn_dt_1_p4 : 'Stop port',
        dn_dt_1_p5 : 'Result port (Signal 1)',
        dn_dt_1_p6 : 'Trigger port (Signal 2)',
        dn_dt_1_p7 : 'Fail wait',
        dn_dt_1_p8 : 'Input port list',
        dn_dt_1_p9 : 'Input port count',
        dn_dt_1_p10 : 'Output port list',
        dn_dt_1_p11 : 'Output port count',
        dn_dt_1_p12 : 'Fail sound effect',
        dn_dt_1_p13 : 'Success sound effect',
        dn_dt_8_p3 : 'Playback volume',
        p9_zbxx_col_id : 'ID',
        p9_zbxx_lbl_lang_yue : 'Cantonese(chs)',
        p9_zbxx_lbl_runtime_info : 'Runtime Info',
        p9_zbxx_lbl_normal_running : 'Normal Running',
        p9_zbxx_lbl_emergency : 'Emergency Mode',
        p9_zbxx_btn_switch : 'Switch',
        p9_zbxx_lbl_current_theme : 'Current: ',
        p9_zbxx_lbl_switch_theme : 'Switch theme: ',
        p9_zbxx_lbl_boot_theme_default : 'Boot default: ',
        p9_zbxx_tab_info_short : 'Info',
        p9_zbxx_tab_setting_short : 'Setting',
        p9_zbxx_tab_port_short : 'Port',
        p9_zbxx_lbl_elapsed : 'Elapsed',
        p9_zbxx_msg_sel_correct_theme_1_5 : 'Please select a valid theme (1-5)',
        p9_zbxx_msg_theme_switching_short : 'Switching theme...',
        p9_zbxx_msg_please_sel_boot_theme : 'Please select a boot theme',
        p9_zbxx_msg_sel_correct_theme_0_5 : 'Please select a valid theme (0-5)',
        p9_zbxx_lbl_theme_short : 'Theme',
        p9_zbxx_lbl_progress : 'Progress:',
        p9_zbxx_lbl_scene_time : 'Scene time:',
        p9_zbxx_lbl_current_scene : 'Current Scene',
        p9_zbxx_lbl_not_started : 'Not Started',
        p9_zbxx_lbl_select_subdev_type : 'Select Device Type',
        p9_zbxx_lbl_device_offline : 'Device Offline',
        p9_zbxx_lbl_show_limit_empty : 'No remaining rounds',
        p9_zbxx_lbl_show_limit_low : 'Few rounds remaining',
        p9_zbxx_lbl_no_data : 'No Data',
        p9_zbxx_cfm_upgrade_theme : 'Confirm theme upgrade?',
        p9_zbxx_lbl_same_port_mutex : 'Same-port mutex',
        p9_zbxx_lbl_net_reconnect_try : 'Network reconnect retries',
        p9_zbxx_lbl_audio_control_option : 'Audio control option',
        p9_zbxx_lbl_input_port_module : 'Input Port Module',
        p9_zbxx_lbl_output_port_module : 'Output Port Module',
        p9_zbxx_lbl_port_status : 'Port Status',
        p9_zbxx_lbl_board_offline : 'Board Offline',
        p9_yxjl_lbl_board : 'Main Controller',
        p9_yxjl_ph_select_board : 'Please select a main controller',
        p9_yxjl_col_boot_count : 'Run Count',
        p9_yxjl_col_date : 'Date',
        p9_yxjl_col_detail : 'Details',
        p9_yxjl_btn_export_exec_record : 'Export Execution Record',
        p9_yxjl_col_log : 'Log',
        p9_yxjl_btn_view : 'View',
        p9_yxjl_btn_download : 'Download',
        p9_yxjl_col_scene : 'Scene',
        p9_yxjl_col_scene_name : 'Scene Name',
        p9_yxjl_col_enter_time : 'Start Time',
        p9_yxjl_col_leave_time : 'End Time',
        p9_yxjl_col_duration : 'Duration',
        p9_yxjl_tab_main_task : 'Main Task',
        p9_yxjl_lbl_run_log : 'Run Log',
        p9_yxjl_empty_no_board : 'No Main Controller',
        p9_yxjl_unit_hour : ' hr',
        p9_yxjl_unit_minute : ' min',
        p9_yxjl_unit_second : ' sec',
        p9_yxjl_msg_download_failed : 'Download failed',
        p9_yxjl_msg_log_url_missing : 'Unable to get log file URL',
        p9_yxjl_sheet_run_record : 'Run Record',
        p9_yxjl_file_exec_record : 'ExecutionRecord',
        p9_yxjl_file_default : 'RunRecord',
        p9_yxjl_msg_export_success : 'Run record exported as ',
        p9_yxjl_msg_export_failed : 'Failed to export run record: ',
        p9_yxjl_xlsx_col_time : 'Time',
        p9_yxjl_xlsx_col_tick : 'Timestamp',
        p9_yxjl_xlsx_col_device_category : 'Device Category',
        p9_yxjl_xlsx_col_device_index : 'Device Index',
        p9_yxjl_xlsx_col_operation_code : 'Operation Code',
        p9_yxjl_xlsx_col_parameter : 'Parameter',
        p9_yxjl_xlsx_col_operation : 'Operation',

        // --- action_name i18n keys (an_) ---
        'an_0_1': 'Start',
        'an_0_0': 'Stop',
        'an_1_1': 'Start',
        'an_1_0': 'Stop',
        'an_2_1': 'Start',
        'an_2_0': 'Stop',
        'an_3_1': 'Start',
        'an_3_0': 'Stop',
        'an_4_1': 'Start',
        'an_4_0': 'Stop',
        'an_4_2': 'Set Brightness',
        'an_4_11': 'Toggle',
        'an_5_0': 'Unlock',
        'an_5_1': 'Lock',
        'an_5_2': 'Toggle',
        'an_7_1': 'On',
        'an_7_0': 'Off',
        'an_7_2': 'Set Brightness',
        'an_8_1': 'Play',
        'an_8_0': 'Stop',
        'an_8_4': 'Set Volume',
        'an_9_0': 'Stop',
        'an_9_1': 'Play',
        'an_10_1': 'Play',
        'an_10_0': 'Stop',
        'an_10_2': 'Resume',
        'an_10_3': 'Pause',
        'an_10_4': 'Set Volume',
        'an_10_5': 'Priority Play',
        'an_11_1': 'Play',
        'an_11_0': 'Stop',
        'an_11_2': 'Resume',
        'an_11_3': 'Pause',
        'an_11_5': 'Loop Mode',
        'an_12_1': 'Play',
        'an_12_2': 'Resume',
        'an_12_3': 'Pause',
        'an_13_1': 'Start',
        'an_13_0': 'Stop',
        'an_13_2': 'Resume',
        'an_13_3': 'Pause',
        'an_14_0': 'Stop',
        'an_14_1': 'Start',
        'an_14_2': 'Assign',
        'an_14_4': 'Add',
        'an_14_5': 'Subtract',
        'an_14_6': 'Multiply',
        'an_14_7': 'Divide',
        'an_14_10': 'Random',
        'an_14_12': 'Add',
        'an_14_13': 'Subtract',
        'an_14_14': 'Multiply',
        'an_14_15': 'Divide',
        'an_30_1': 'Start',
        'an_30_0': 'Stop',
        'an_30_8': 'Reset Timer',
        'an_30_9': 'Flow Reset',
        'an_30_3': 'Flow Skip',
        'an_31_1': 'Force',
        'an_33_1': 'Netdev Ready',
        'an_32_1': 'Skip',
        'an_34_1': 'Room Clear',
        'an_35_1': 'Theme Start',
        'an_36_1': 'Theme End',
        'an_39_1': 'Scene Trigger',
        'an_40_1': 'Language Set',

        // --- logic_name i18n keys (ln_) ---
        'ln_1_true': 'Success',
        'ln_1_false': 'Fail',
        'ln_2_true': 'Success',
        'ln_2_false': 'Fail',
        'ln_3_true': 'Active',
        'ln_3_false': 'Inactive',
        'ln_3_2': 'Equal',
        'ln_3_3': 'Greater',
        'ln_3_4': 'Greater or Equal',
        'ln_3_5': 'Less',
        'ln_3_6': 'Less or Equal',
        'ln_3_7': 'Not Equal',
        'ln_4_true': 'Active',
        'ln_4_false': 'Inactive',
        'ln_5_true': 'Closed',
        'ln_5_false': 'Open',
        'ln_6_true': 'Open',
        'ln_6_false': 'Closed',
        'ln_7_true': 'On',
        'ln_7_false': 'Off',
        'ln_8_true': 'On',
        'ln_8_false': 'Off',
        'ln_9_true': 'On',
        'ln_9_false': 'Off',
        'ln_10_true': 'On',
        'ln_10_false': 'Off',
        'ln_11_true': 'On',
        'ln_11_false': 'Off',
        'ln_12_true': 'On',
        'ln_12_false': 'Off',
        'ln_13_true': 'Success',
        'ln_13_false': 'Fail',
        'ln_13_2': 'Event Received',
        'ln_14_2': 'Equal',
        'ln_14_3': 'Greater',
        'ln_14_4': 'Greater or Equal',
        'ln_14_5': 'Less',
        'ln_14_6': 'Less or Equal',
        'ln_14_7': 'Not Equal',
        'ln_14_8': 'Changed to',
        'ln_31_true' : 'Always true',
        'ln_33_true' : 'Ready',
        'an_37_1' : 'Flow Reset',
        'an_37_2' : 'Flow Pause',
        'an_37_3' : 'Flow Speed Up',
        'an_37_4' : 'Flow Speed Down',

        tn_task_1 : 'Main Task',
        tn_task_2 : 'Task 2',
        tn_task_3 : 'Task 3',
        tn_task_4 : 'Task 4',
        tn_task_5 : 'Task 5',
        tn_task_6 : 'Task 6',
        tn_task_7 : 'Task 7',
        tn_task_8 : 'Task 8',
        tn_task_9 : 'Task 9',
        tn_task_10 : 'Task 10',
        tn_task_11 : 'Task 11',
        tn_task_12 : 'Task 12',
        tn_task_13 : 'Task 13',
        tn_task_14 : 'Task 14',
        tn_task_15 : 'Task 15',
        tn_task_16 : 'Task 16',
        tn_task_17 : 'Task 17',
        tn_task_18 : 'Task 18',
        tn_task_19 : 'Task 19',
        tn_task_20 : 'Task 20',
        tn_task_21 : 'Task 21',
        tn_task_22 : 'Task 22',
        tn_task_23 : 'Task 23',
        tn_task_24 : 'Task 24',
        tn_task_25 : 'Task 25',
        tn_task_26 : 'Task 26',
        tn_task_27 : 'Task 27',
        tn_task_28 : 'Task 28',
        tn_task_29 : 'Task 29',
        tn_task_30 : 'Task 30',
        tn_task_31 : 'Task 31',
        tn_task_32 : 'Task 32',
        tn_task_33 : 'Task 33',
        tn_task_34 : 'Task 34',
        tn_task_35 : 'Task 35',
        tn_task_36 : 'Task 36',
        tn_task_37 : 'Task 37',
        tn_task_38 : 'Task 38',
        tn_task_39 : 'Task 39',
        tn_task_40 : 'Task 40',
        tn_task_41 : 'Task 41',
        tn_task_42 : 'Task 42',
        tn_task_43 : 'Task 43',
        tn_task_44 : 'Task 44',
        tn_task_45 : 'Task 45',
        tn_task_46 : 'Task 46',
        tn_task_47 : 'Task 47',
        tn_task_48 : 'Task 48',
        tn_task_49 : 'Task 49',
        tn_task_50 : 'Task 50',
        tn_task_51 : 'Task 51',
        tn_task_52 : 'Task 52',
        tn_task_53 : 'Task 53',
        tn_task_54 : 'Task 54',
        tn_task_55 : 'Task 55',
        tn_task_56 : 'Task 56',
        tn_task_57 : 'Task 57',
        tn_task_58 : 'Task 58',
        tn_task_59 : 'Task 59',
        tn_task_60 : 'Task 60',
        tn_task_61 : 'Task 61',
        tn_task_62 : 'Task 62',
        tn_task_63 : 'Task 63',
        tn_task_64 : 'Task 64',
        tn_task_65 : 'Task 65',
        tn_task_66 : 'Task 66',
        tn_task_67 : 'Task 67',
        tn_task_68 : 'Task 68',
        tn_task_69 : 'Task 69',
        tn_task_70 : 'Task 70',
        tn_task_71 : 'Task 71',
        tn_task_72 : 'Task 72',
        tn_task_73 : 'Task 73',
        tn_task_74 : 'Task 74',
        tn_task_75 : 'Task 75',
        tn_task_76 : 'Task 76',
        tn_task_77 : 'Task 77',
        tn_task_78 : 'Task 78',
        tn_task_79 : 'Task 79',
        tn_task_80 : 'Task 80',
        tn_task_81 : 'Task 81',
        tn_task_82 : 'Task 82',
        tn_task_83 : 'Task 83',
        tn_task_84 : 'Task 84',
        tn_task_85 : 'Task 85',
        tn_task_86 : 'Task 86',
        tn_task_87 : 'Task 87',
        tn_task_88 : 'Task 88',
        tn_task_89 : 'Task 89',
        tn_task_90 : 'Task 90',
        tn_task_91 : 'Task 91',
        tn_task_92 : 'Task 92',
        tn_task_93 : 'Task 93',
        tn_task_94 : 'Task 94',
        tn_task_95 : 'Task 95',
        tn_task_96 : 'Task 96',
        tn_task_97 : 'Task 97',
        tn_task_98 : 'Task 98',
        tn_task_99 : 'Task 99',
        tn_task_100 : 'Task 100',
        tn_task_101 : 'Task 101',
        tn_task_102 : 'Task 102',
        tn_task_103 : 'Task 103',
        tn_task_104 : 'Task 104',
        tn_task_105 : 'Task 105',
        tn_task_106 : 'Task 106',
        tn_task_107 : 'Task 107',
        tn_task_108 : 'Task 108',
        tn_task_109 : 'Task 109',
        tn_task_110 : 'Task 110',
        tn_task_111 : 'Task 111',
        tn_task_112 : 'Task 112',
        tn_task_113 : 'Task 113',
        tn_task_114 : 'Task 114',
        tn_task_115 : 'Task 115',
        tn_task_116 : 'Task 116',
        tn_task_117 : 'Task 117',
        tn_task_118 : 'Task 118',
        tn_task_119 : 'Task 119',
        tn_task_120 : 'Task 120',
        tn_task_121 : 'Task 121',
        tn_task_122 : 'Task 122',
        tn_task_123 : 'Task 123',
        tn_task_124 : 'Task 124',
        tn_task_125 : 'Task 125',
        tn_task_126 : 'Task 126',
        tn_task_127 : 'Task 127',
        tn_task_128 : 'Task 128',




    },
    organization,
    themeSceneExport,
    role: {
        permission: 'permission',
    },
    user: {

    },
    title: {

    },

































































































































}
